/**
 * InsulaCharter - Portuguese (Portugal) Localization
 * Adapted from AlguerHouse for boat rental
 */

const pt = {
  // ============================================
  // MARKUP INCLUSIVE (request/approval)
  // ============================================
  markupInclusive: {
    title: 'Preço tudo incluído',
    subtitle: 'Solicita que a margem da plataforma seja incluída no preço apresentado',
    rental: 'Aluguer',
    excursion: 'Excursões',
    statusActive: 'Ativo',
    statusPending: 'Aprovação pendente',
    statusInactive: 'Não ativo',
    request: 'Solicitar',
    requested: 'Pedido enviado',
    requestError: 'Erro ao enviar o pedido',
    approve: 'Aprovar',
    reject: 'Rejeitar',
    approved: 'Pedido aprovado',
    rejected: 'Pedido rejeitado',
    actionError: 'Erro na operação',
    adminTitle: 'Margem incluída',
    adminHint: 'Aprova ou rejeita os pedidos de preço tudo incluído por filial.',
    vendorHint: 'Até à aprovação, o preço mantém-se aditivo (margem adicionada).',
  },
  // ============================================
  // METADATA & SEO
  // ============================================
  metadata: {
    siteTitle: 'InsulaCharter - Aluguer de Barcos na Sardenha',
    siteDescription: 'Encontra o barco perfeito para a tua aventura nas águas cristalinas da Costa Esmeralda e das enseadas da Sardenha.',
    loginTitle: 'Iniciar Sessão - InsulaCharter',
    loginDescription: 'Inicia sessão na tua conta InsulaCharter',
    registerTitle: 'Registar - InsulaCharter',
    registerDescription: 'Cria a tua conta InsulaCharter',
  },

  // ============================================
  // COMMON / SHARED
  // ============================================
  common: {
    all: 'Todos',
    loading: 'A carregar...',
    error: 'Erro',
    errorPrefix: 'Erro: ',
    serverError: 'Erro do servidor',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    success: 'Sucesso',
    save: 'Guardar',
    saving: 'A guardar...',
    create: 'Criar',
    edit: 'Editar',
    delete: 'Eliminar',
    search: 'Pesquisar',
    searchNow: 'PESQUISAR AGORA',
    back: 'Voltar',
    next: 'Seguinte',
    close: 'Fechar',
    yes: 'Sim',
    no: 'Não',
    free: 'Grátis',
    included: 'Incluído',
    day: 'dia',
    days: 'dias',
    guest: 'passageiro',
    guests: 'passageiros',
    passengers: 'passageiros',
    boat: 'Barco',
    meters: 'metros',
    person: 'Pessoa',
    persons: 'Pessoas',
    total: 'Total',
    price: 'Preço',
    perDay: '/dia',
    today: 'Hoje',
    uploading: 'A carregar...',
    sending: 'A enviar...',
    hour: 'hora',
    hours: 'horas',
    loginRequired: 'É necessário iniciar sessão',
    from: 'A partir de',
  },

  // ============================================
  // NAVBAR
  // ============================================
  navbar: {
    logo: 'InsulaCharter',
    maintenanceMode: 'MODO DE MANUTENÇÃO - O site só está visível para ti',
    maintenanceShort: 'MANUTENÇÃO',
    exitMaintenance: 'Sair',
    accountActive: 'Conta Ativa',
    roleHost: 'Proprietário de Barco',
    roleGuest: 'Convidado',
    adminPanel: 'Painel',
    adminSettings: 'Definições',
    myTrips: 'Os Meus Aluguers',
    myRequests: 'Os meus pedidos',
    logout: 'Terminar Sessão',
    login: 'Iniciar Sessão',
  },

  // ============================================
  // FOOTER
  // ============================================
  footer: {
    description: 'Experiências náuticas exclusivas na Sardenha, cuidadas com paixão para garantir o máximo conforto no mar.',
    quickLinks: 'Links Rápidos',
    exploreBoats: 'Explorar a Frota',
    reservedArea: 'Área Reservada',
    contacts: 'Contactos',
    location: 'Sardenha, Itália',
    copyright: '© 2026 InsulaCharter.',
  },

  // ============================================
  // HOMEPAGE
  // ============================================
  home: {
    tagline: 'Sardenha • Costa Esmeralda',
    welcomeTitle: 'O Mar Espera-te',
    welcomeSubtitle: 'Encontra o barco perfeito para a tua aventura nas águas cristalinas da Costa Esmeralda e das enseadas da Sardenha.',
    allPorts: 'Todos os portos',
    passengersPlaceholder: 'Passageiros',
    passenger1: '1 passageiro',
    passengers2: '2 passageiros',
    passengers3: '3 passageiros',
    passengers4: '4 passageiros',
    passengers5: '5 passageiros',
    passengers6Plus: '6+ passageiros',
    ourDestinations: 'Os Nossos Destinos',
    categoryCoastline: 'Costa',
    categoryIslands: 'Ilhas',
    categoryBays: 'Enseadas',
    categoryOpen: 'Mar Alto',
    boatsInSardinia: 'Barcos na Sardenha',
    noBoatsTitle: 'Nenhum barco disponível',
    noBoatsMessage: 'Tenta ajustar os filtros de pesquisa',
    resetSearch: 'Repor pesquisa',
    boatFound: 'barco encontrado',
    boatsFound: 'barcos encontrados',
    noResultsTitle: 'Nenhum barco encontrado.',
    noResultsMessage: 'Tenta ajustar os critérios de pesquisa',
    showAllBoats: 'Mostrar todos os barcos',
    verifiedFleet: 'Frota certificada e verificada',
    insurance: 'seguro',
    startDate: 'Data de partida',
    endDate: 'Data de regresso',
    noLicense: 'Sem necessidade de carta náutica',
    // Hero
    premiumSelection: 'SELEÇÃO PREMIUM INSULA CHARTER',
    heroDescription: 'Explora as enseadas mais recônditas da Sardenha com a nossa frota premium. O luxo encontra a liberdade.',
    // Benefits bar
    benefitFlexibility: 'Flexibilidade Total',
    benefitInstant: 'Aluguer Instantâneo',
    benefitCertified: 'Charters Certificados',
    // Catalog
    searchResults: 'Resultados da Pesquisa',
    catalogTitle: 'Catálogo de Barcos',
    searchResultsSubtitle: 'Encontrámos {count} barcos que correspondem aos teus critérios.',
    catalogSubtitle: 'Descobre os barcos mais exclusivos selecionados para ti.',
    resetFilters: 'Repor Todos os Filtros',
    noResults: 'Ups! Não há barcos disponíveis para estes critérios.',
    noResultsHint: 'Tenta ajustar os filtros ou alargar a tua pesquisa.',
    resetFiltersBtn: 'Repor Filtros',
    loadingBoats: 'A carregar barcos...',
    loadingMap: 'A carregar mapa...',
    // Destinations section
    exclusiveDestinations: 'Os Destinos Mais Exclusivos',
    exclusiveDestinationsDesc: 'Da Costa Esmeralda às enseadas selvagens da Ogliastra. Navega até ao paraíso.',
    exploreMap: 'Explorar o Mapa',
  },

  // ============================================
  // NAVBAR (extended)
  // ============================================
  navbarExt: {
    home: 'Início',
    fleet: 'Frota',
    excursions: 'Excursões',
    destinations: 'Destinos',
    blog: 'Blog',
    vendorPanel: 'Painel do Vendedor',
    vendorRole: 'Vendedor',
    lightTheme: 'Tema claro',
    darkTheme: 'Tema escuro',
    navigation: 'Navegação',
    administration: 'Administração',
    account: 'Conta',
    settings: 'Definições',
    services: 'Serviços',
  },

  // ============================================
  // FOOTER (extended)
  // ============================================
  footerExt: {
    home: 'Início',
    destinations: 'Destinos',
    support: 'Suporte',
    helpCenter: 'Centro de Ajuda',
    termsConditions: 'Termos e Condições',
    cookiePrivacy: 'Cookies e Privacidade',
    kaskoInsurance: 'Seguro Casco',
    securePayments: 'Pagamentos Seguros',
  },

  // ============================================
  // SEARCH SECTION
  // ============================================
  searchSection: {
    city: 'Cidade',
    allCities: 'Todas',
    allCitiesLong: 'Todas as cidades',
    noCities: 'Nenhuma cidade disponível',
    dates: 'Datas',
    dateStart: 'Início',
    dateEnd: 'Fim',
    times: 'Horários',
    pickup: 'Levantamento',
    dropoff: 'Devolução',
    guests: 'Passageiros',
    passengers: 'Passageiros',
    license: 'Carta',
    licenseAll: 'Todas',
    licenseNo: 'Não',
    search: 'Pesquisar',
  },

  // ============================================
  // CATALOG TOOLBAR & FILTERS
  // ============================================
  catalog: {
    // Toolbar
    filters: 'Filtros',
    searchPlaceholder: 'Pesquisar barco, porto, descrição...',
    sortPriceAsc: 'Preço: do mais baixo ao mais alto',
    sortPriceDesc: 'Preço: do mais alto ao mais baixo',
    sortRating: 'Classificação',
    sortReviews: 'Mais avaliados',
    sortNewest: 'Mais recentes',
    sortName: 'Nome A-Z',
    sortDefault: 'Ordenar por',
    viewGrid: 'Vista em grelha',
    viewList: 'Vista em lista',
    viewMap: 'Vista em mapa',
    boatFound: 'barco encontrado',
    boatsFound: 'barcos encontrados',
    // Filters
    boatType: 'Tipo de Barco',
    dailyPrice: 'Preço Diário',
    priceRange: 'Intervalo disponível',
    passengerCapacity: 'Capacidade de Passageiros',
    departureCity: 'Cidade de Partida',
    allCities: 'Todas as cidades',
    options: 'Opções',
    noLicense: 'Sem carta náutica',
    skipperAvailable: 'Skipper disponível',
    resetFilters: 'Repor Filtros',
    showResults: 'Mostrar resultados',
    // Pagination
    showing: 'A mostrar',
    of: 'de',
    results: 'resultados',
    prevPage: 'Página anterior',
    nextPage: 'Página seguinte',
    pageOf: 'Página {current} de {total}',
  },

  // ============================================
  // BOAT CARD (extended)
  // ============================================
  boatCardExt: {
    premiere: 'Insula Première',
    licenseRequired: 'Carta Necessária',
    noLicense: 'Sem Carta',
    unavailable: 'Indisponível',
    startingFrom: 'A partir de',
    from: 'a partir de',
    seasonalRate: 'Tarifa sazonal',
    perDay: '/dia',
    perHalfDay: '/meio-dia',
    perWeek: '/semana',
    perMonth: '/mês',
    shortStaySurcharge: 'Suplemento de estadia curta',
    length: 'Comprimento',
    passengers: 'Passageiros',
    cabins: 'Cabines',
    bathrooms: 'Casas de banho',
    engine: 'Motor',
    skipperIncluded: 'Skipper Incluído',
    skipperAvailable: 'Skipper Disponível',
    viewAlternatives: 'Ver Alternativas',
    exploreDetails: 'Explorar Detalhes',
    alternatives: 'Alternativas',
    details: 'Detalhes',
    license: 'Carta',
    noLicenseShort: 'Sem Carta',
    people: 'pessoas',
    forDays: 'durante {days} dias',
    premium: 'Premium',
  },

  // ============================================
  // DATE RANGE PICKER
  // ============================================
  datePicker: {
    title: 'Seleciona as datas de aluguer',
    clearSelection: 'Limpar seleção',
    confirmDates: 'Confirmar Datas',
    boarding: 'Embarque',
    disembark: 'Desembarque',
    day: 'dia',
    days: 'dias',
    selectBoarding: 'Seleciona a data de embarque',
    selectDisembark: 'Seleciona a data de desembarque (clica na mesma data para um aluguer de um único dia)',
    available: 'Disponível',
    notAvailable: 'Indisponível',
    halfDay: 'Meio dia',
    morningFree: 'Manhã disponível',
    morningBooked: 'Manhã reservada',
    afternoonFree: 'Tarde disponível',
    afternoonBooked: 'Tarde reservada',
    weekdayMon: 'Seg',
    weekdayTue: 'Ter',
    weekdayWed: 'Qua',
    weekdayThu: 'Qui',
    weekdayFri: 'Sex',
    weekdaySat: 'Sáb',
    weekdaySun: 'Dom',
    weekdayFullMon: 'Segunda-feira',
    weekdayFullTue: 'Terça-feira',
    weekdayFullWed: 'Quarta-feira',
    weekdayFullThu: 'Quinta-feira',
    weekdayFullFri: 'Sexta-feira',
    weekdayFullSat: 'Sábado',
    weekdayFullSun: 'Domingo',
    monthJan: 'Janeiro',
    monthFeb: 'Fevereiro',
    monthMar: 'Março',
    monthApr: 'Abril',
    monthMay: 'Maio',
    monthJun: 'Junho',
    monthJul: 'Julho',
    monthAug: 'Agosto',
    monthSep: 'Setembro',
    monthOct: 'Outubro',
    monthNov: 'Novembro',
    monthDec: 'Dezembro',
  },

  // ============================================
  // BOAT TYPES
  // ============================================
  boatTypes: {
    yacht: 'Iate',
    sailboat: 'Veleiro',
    motorboat: 'Barco a Motor',
    catamaran: 'Catamarã',
    dinghy: 'Bote',
    jetski: 'Mota de Água',
  },

  // ============================================
  // BOAT CARD
  // ============================================
  boatCard: {
    exclusive: 'Premium',
    pricePerDay: 'Preço diário',
    licenseRequired: 'Carta necessária',
    noLicenseRequired: 'Sem necessidade de carta',
    capacity: 'Capacidade',
    length: 'Comprimento',
    power: 'Potência',
  },

  // ============================================
  // BOAT (New fields)
  // ============================================
  boat: {
    linkCopied: 'Link copiado para a área de transferência!',
    port: 'Porto de Partida',
    enginePower: 'Potência do Motor',
    skipperAvailable: 'Skipper Disponível',
    skipperIncluded: 'Skipper Incluído',
    hostessAvailable: 'Hospedeira Disponível',
    noLicense: 'Sem Necessidade de Carta',
    licenseRequired: 'Carta Necessária',
    amenities: 'Equipamento a Bordo',
    extras: 'Serviços Extra',
    perStay: 'por aluguer',
    perDay: 'por dia',
    perPerson: 'por pessoa',
    perPersonPerDay: 'por pessoa por dia',
    coverImage: 'Foto de Capa',
    selectCover: 'Definir como capa',
    freeService: 'Grátis',
    externalServicesTitle: 'Serviços disponíveis neste porto',
    externalServicesEmpty: 'Nenhum serviço externo disponível neste porto.',
    externalServicesLoading: 'A carregar serviços...',
    externalServicesPlaceholder: 'Este barco oferece serviços adicionais',
    externalServicesContactUs: 'Contacta-nos para mais informações sobre os serviços disponíveis.',
    availableServices: 'Serviços selecionados para este barco',
    fromPrice: 'a partir de €{price}',
    nProvidersAvailable: '{count} fornecedores disponíveis',
    anonymousProvider: 'Fornecedor',
    externalServiceCategoryMobility: 'Aluguer / Mobilidade',
    externalServiceCategoryOther: 'Serviço',
    requestQuote: 'Pedir orçamento',
    requestQuoteTitle: 'Pedir orçamento',
    requestQuoteDate: 'Data preferida',
    requestQuoteGuests: 'Número de pessoas',
    requestQuoteNotes: 'Notas (opcional)',
    requestQuoteName: 'O teu nome',
    requestQuoteEmail: 'Email',
    requestQuotePhone: 'Telefone',
    requestQuoteSubmit: 'Enviar pedido',
    requestQuoteSuccess: 'Pedido enviado. O fornecedor entrará em contacto contigo brevemente.',
    requestQuoteAuthHint: 'Deixa os teus dados de contacto para o fornecedor poder responder',
  },

  // ============================================
  // REVIEWS (Reviews)
  // ============================================
  reviews: {
    title: 'Gestão de Avaliações',
    newReview: 'Nova Avaliação',
    editReview: 'Editar Avaliação',
    noReviews: 'Sem avaliações',
    addFirst: 'Adiciona a primeira avaliação para os teus barcos',
    authorName: 'Nome do Autor',
    rating: 'Classificação',
    comment: 'Comentário',
    reviewDate: 'Data da Avaliação',
    adminResponse: 'Resposta do Administrador',
    isVisible: 'Avaliação visível ao público',
    hidden: 'Oculta',
    stars: 'estrelas',
    star: 'estrela',
    averageRating: 'Média',
    totalReviews: 'avaliações',
    selectBoat: 'Seleciona um barco',
    deleteConfirm: 'Queres eliminar esta avaliação?',
    created: 'Avaliação criada com sucesso',
    updated: 'Avaliação atualizada com sucesso',
    deleted: 'Avaliação eliminada com sucesso',
    showReview: 'Mostrar',
    hideReview: 'Ocultar',
  },

  // ============================================
  // BOAT DETAIL
  // ============================================
  boatDetail: {
    backButton: 'Explorar a Frota',
    notFound: 'Barco não encontrado.',
    loginRequired: 'Inicia sessão para reservar.',
    selectDates: 'Seleciona as datas na pesquisa.',
    characteristics: 'Características',
    description: 'Descrição',
    tagSkipper: 'Skipper Disponível',
    tagInsured: 'Seguro Incluído',
    tagSupport: 'Suporte 24/7',
    whereIsIt: 'Porto de partida',
    locationDescription: 'Localizado no porto de {location}, um dos mais exclusivos da Sardenha.',
    excellentPosition: 'Localização Estratégica',
    homePort: 'Porto Base',
    rate: 'Tarifa',
    rental: 'Aluguer',
    passengersLabel: 'Passageiros',
    extrasOptional: 'Serviços Extra (Opcionais)',
    fuelPolicy: 'Combustível',
    extrasTotal: 'Serviços extra',
    bookNow: 'RESERVAR AGORA',
    processing: 'A PROCESSAR...',
    protectionBadge: 'Proteção InsulaCharter Garantida',
    paymentMethod: 'Método de Pagamento',
    selectPaymentMethod: 'Seleciona um método de pagamento',
    noPaymentMethods: 'Sem métodos de pagamento guardados',
    addPaymentMethod: 'Adicionar um método de pagamento',
    cashDescription: 'Pagar em dinheiro no levantamento',
    guaranteeRequired: 'Caução necessária',
    guaranteeAmount: 'Valor da caução',
    selectGuaranteeCard: 'Seleciona o cartão para a caução',
    cashNoCard: 'Pagar em dinheiro (confirmação do administrador necessária)',
    cashNoCardDescription: 'Sem cartão de caução, a reserva requer confirmação manual',
    specifications: 'Especificações Técnicas',
    length: 'Comprimento',
    beam: 'Boca',
    engine: 'Motor',
    fuelCapacity: 'Depósito de Combustível',
    maxSpeed: 'Velocidade Máxima',
  },

  // ============================================
  // DASHBOARD (GUEST)
  // ============================================
  dashboard: {
    title: 'Área Pessoal',
    greeting: 'Bem-vindo de volta, {name}. Gere os teus aluguers na Sardenha.',
    profileSailor: 'Perfil de Navegador',
    menuUpcomingTrips: 'Próximos Aluguers',
    menuPaymentMethods: 'Métodos de Pagamento',
    menuSaved: 'Guardados',
    menuPersonalInfo: 'Dados Pessoais',
    confirmedBookings: 'Reservas Confirmadas',
    pickupDate: 'Levantamento',
    returnDate: 'Devolução',
    receipt: 'Recibo',
    cancelBooking: 'Cancelar',
    noTripsTitle: 'Sem aluguers confirmados',
    noTripsMessage: 'O mar espera por ti. Começa já a planear a tua próxima aventura!',
    exploreBoats: 'Explorar a Frota',
    historyAndCancelled: 'Histórico e Cancelados',
    statusCancelled: 'Cancelada',
    myBookings: 'As Minhas Reservas',
    upcomingTrips: 'Próximos Aluguers',
    paymentMethods: 'Métodos de Pagamento',
    saved: 'Guardados',
    personalInfo: 'Dados Pessoais',
    noBookings: 'Nenhum aluguer reservado',
    noBookingsDesc: 'O mar espera por ti. Começa já a planear a tua próxima aventura!',
    savedComingSoon: 'Barcos Guardados',
    savedDescription: 'Funcionalidade brevemente disponível. Em breve poderás guardar os teus barcos favoritos.',
  },

  // ============================================
  // ADMIN DASHBOARD
  // ============================================
  admin: {
    title: 'Painel de Administração',
    subtitle: 'Gestão centralizada do InsulaCharter Sardenha.',
    addBoat: 'Adicionar Barco',
    bookingsTitle: 'Reservas',
    bookingsSubtitle: 'Gerir reservas',

    // Boat port/marina (for external services matching)
    boatPortMarina: 'Porto/Marina',
    boatPortMarinaHint: 'Os serviços externos visíveis aos clientes dependem do porto selecionado aqui.',
    boatPortMarinaNone: '— Sem porto —',
    boatPortMarinaLoading: 'A carregar portos...',

    // Role management
    changeRole: 'Alterar Função',
    changeRoleConfirm: 'Tens a certeza de que queres alterar a função deste utilizador?',
    changeRoleSuccess: 'Função atualizada com sucesso',
    changeRoleAdminWarning: 'Isto concede acesso total de administrador à plataforma.',
    changeRoleWarningBoats: 'Este utilizador tem {count} barcos ativos. Alterar a função irá desativar os seus anúncios.',
    changeRoleForce: 'Continuar mesmo assim',
    cannotChangeOwnRole: 'Não podes alterar a tua própria função',
    cannotDemoteLastAdmin: 'Não é possível remover o último administrador da plataforma',
    roleAlreadyAssigned: 'O utilizador já tem esta função',
    confirmAdminRequired: 'É necessária confirmação explícita para promover a Administrador',
    invalidRole: 'Função inválida',
    role_hub_internal_only: 'Esta conta (ADMIN ou Prestador de Serviços) só é gerida a partir do hub, não aqui.',
    newRole: 'Nova função',
    vendorStatusOption: 'Estado inicial do vendedor',

    // Service Provider invitations
    inviteServiceProvider: 'Convidar Fornecedor',
    inviteEmailLabel: 'Email do fornecedor',
    inviteNameLabel: 'Nome (opcional)',
    inviteDesc: 'Será enviado um email com um link de registo válido durante 48 horas.',
    inviteSend: 'Enviar Convite',
    inviteSent: 'Convite enviado com sucesso',
    inviteAcceptTitle: 'Concluir Registo',
    inviteAcceptDesc: 'Foste convidado a juntar-te ao InsulaCharter como Prestador de Serviços.',

    // Preview links
    previewVendor: 'Pré-visualizar Vendedor',
    previewServiceProvider: 'Pré-visualizar Fornecedor',

    // Tabs
    tabDashboard: 'Visão Geral',
    tabCalendar: 'Calendário',
    tabMyBoats: 'Frota',
    tabReviews: 'Avaliações',
    tabBookings: 'Reservas de barcos',
    tabClientBookings: 'Reservas de Clientes',
    tabServices: 'Serviços a Bordo',
    calendarTitle: 'Calendário de Reservas',
    calendarSubtitle: 'Vê todas as reservas da tua frota',
    fleetOverview: 'Visão Geral da Frota',

    // Stats
    statsOverview: 'Visão Geral',
    statsTotalRevenue: 'Receita Total',
    statsConfirmed: 'confirmadas',
    statsUniqueClients: 'Clientes Únicos',
    statsRegisteredClients: 'clientes registados',
    statsActiveBoats: 'Barcos Ativos',
    statsInFleet: 'na frota',
    statsPending: 'Pendentes',
    statsToConfirm: 'a confirmar',

    // Economic averages
    economicAverages: 'Médias Económicas',
    avgBookingValue: 'Valor Médio da Reserva',
    avgPricePerDay: 'Preço Diário Médio',
    confirmationRate: 'Taxa de Confirmação',

    // Booking trends
    bookingTrends: 'Tendências de Reservas',
    last30Days: 'Últimos 30 Dias',
    confirmedBookings: 'reservas confirmadas',
    bookingStatus: 'Estado da Reserva',
    statusConfirmed: 'Confirmada',
    statusPending: 'Pendente',
    statusCancelled: 'Cancelada',

    // Pricing tabs
    tabPricingRules: 'Regras de Preços',
    tabPricingCalendar: 'Calendário de Preços',
    tabTariffe: 'Tarifas',
    tabTariffeReadonly: 'Tarifas (só leitura)',
    tabPricing: 'Preços e Promoções',

    // Pricing management (3-step flow)
    pricingTitle: 'Preços',
    pricingSubtitle: 'Consulta proprietários, barcos e preços detalhados',
    pricingBreadcrumbOwners: 'Todos os proprietários',
    pricingSelectOwner: 'Seleciona um proprietário',
    pricingLoadingOwners: 'A carregar proprietários...',
    pricingNoOwnersFound: 'Nenhum proprietário encontrado',
    pricingFilterAll: 'Todos',
    pricingSearchOwner: 'Pesquisar nome ou email...',
    pricingColOwner: 'Proprietário',
    pricingColEmail: 'Email',
    pricingColRole: 'Função',
    pricingColBoats: 'Barcos',
    pricingBoatsOf: 'Barcos de',
    pricingBoatSingular: 'barco',
    pricingBoatPlural: 'barcos',
    pricingNoBoats: 'Este proprietário não tem barcos registados',
    pricingColBoatName: 'Barco',
    pricingColType: 'Tipo',
    pricingColLength: 'Comprimento',
    pricingColPriceDay: '€/dia',
    pricingColPriceHalf: '€/meio-dia',
    pricingColStatus: 'Estado',
    pricingBackToOwners: 'Voltar aos proprietários',
    pricingBackToBoats: 'Voltar aos barcos de',
    pricingLoadingPricing: 'A carregar preços...',
    pricingSearchBoats: 'Pesquisar barco...',
    pricingAllTypes: 'Todos os tipos',
    pricingAllStatuses: 'Todos os estados',

    tabPricePolicies: 'Políticas de Preços',
    tabCoupons: 'Cupões e Promoções',
    tabInviteCodes: 'Códigos de Convite',
    tabAmbassadors: 'Embaixadores',
    tabAmbassadorTiers: 'Níveis de Embaixador',
    tabServicePlatformFee: 'Taxas de Serviço',
    tabExternalServicesPayout: 'Pagamentos de Serviços',
    usersRetrievalError: 'Erro ao obter utilizadores',

    // Fleet management
    fleet: {
      title: 'Gestão da Frota',
      addBoat: 'Adicionar Barco',
      filterAll: 'Todos',
      filterCompany: 'Empresas',
      filterVendor: 'Particulares',
      filterPlatform: 'Plataforma',
      searchPlaceholder: 'Pesquisar barco, proprietário, porto...',
      allTypes: 'Todos os tipos',
      allPorts: 'Todos os portos',
      clearFilters: 'Limpar filtros',
      expandAll: 'Expandir tudo',
      collapseAll: 'Colapsar tudo',
      boat: 'barco',
      boats: 'barcos',
      owner: 'proprietário',
      owners: 'proprietários',
      company: 'Empresa',
      vendor: 'Vendedor Particular',
      platform: 'Plataforma',
      colBoat: 'Barco',
      colType: 'Tipo',
      colPort: 'Porto',
      colCapacity: 'Capacidade',
      colPrice: 'Tarifa/Dia',
      colActions: 'Ações',
      rentalDay: 'dia',
      rentalWeek: 'semana',
      rentalMonth: 'mês',
      viewDetails: 'Ver detalhes',
      edit: 'Editar',
      delete: 'Eliminar',
      empty: 'Nenhum barco na frota',
      emptyHint: 'Começa por adicionar o teu primeiro barco',
      noResults: 'Nenhum barco encontrado',
      noResultsHint: 'Tenta ajustar os filtros de pesquisa',
    },

    // Promotions tab
    tabPromotions: 'Promoções',
    tabSuspensions: 'Suspensões',
    tabMobility: 'Serviços Externos',
    tabMobilityServices: 'Catálogo de Serviços',
    tabExtraCategories: 'Categorias de Serviços',
    tabExternalServices: 'Serviços Externos (API)',
    apiCatalogTitle: 'Catálogo de Serviços do InsulaServices',
    apiCatalogDesc: 'Serviços disponíveis em insulaservices.it para barcos. Clica em "Sincronizar" para atualizar.',
    apiCatalogSync: 'Sincronizar',
    apiCatalogSyncing: 'A sincronizar...',
    apiCatalogEmpty: 'Nenhum serviço disponível. Tenta sincronizar.',
    apiCatalogError: 'Erro ao contactar insulaservices.it',
    apiCatalogQuote: 'Sob consulta',
    apiCatalogPerPerson: '/pessoa',
    extraCategoriesTitle: 'Categorias de Serviços',
    extraCategoriesDesc: 'Cria e gere categorias de serviços. As categorias marcadas como "externas" são visíveis aos clientes e selecionáveis pelos Prestadores de Serviços.',
    extraCategoriesNew: 'Nova categoria',
    extraCategoriesEdit: 'Editar categoria',
    extraCategoriesEmpty: 'Nenhuma categoria configurada',
    extraCategoriesSlug: 'Slug (ID único)',
    extraCategoriesLabel: 'Etiqueta',
    extraCategoriesDescription: 'Descrição',
    extraCategoriesIcon: 'Ícone',
    extraCategoriesIconHint: 'Nome do ícone Lucide (ex.: Bike, Camera, Utensils, Anchor)',
    extraCategoriesColor: 'Cor do emblema',
    extraCategoriesSortOrder: 'Ordem de exibição',
    extraCategoriesVisibility: 'Visibilidade',
    extraCategoriesExternal: 'Externa (visível aos clientes)',
    extraCategoriesExternalShort: 'externa',
    extraCategoriesInternal: 'Interna (apenas admin)',
    extraCategoriesInternalShort: 'interna',
    extraCategoriesProtected: 'Categoria protegida — não pode ser eliminada',
    extraCategoriesProtectedHint: 'As categorias protegidas não podem alterar o slug nem a visibilidade',
    extraCategoriesUsage: 'em uso',
    extraCategoriesMoveUp: 'Mover para cima',
    extraCategoriesMoveDown: 'Mover para baixo',
    extraCategoriesValidation: 'Slug e etiqueta são obrigatórios',
    extraCategoriesCreated: 'Categoria criada',
    extraCategoriesUpdated: 'Categoria atualizada',
    extraCategoriesDeleted: 'Categoria eliminada',
    extraCategoriesConfirmDelete: 'Eliminar esta categoria permanentemente?',
    mobilityServices: 'Serviços de Mobilidade',
    mobilityServicesDesc: 'Gere bicicletas, scooters, trotinetes e transfers disponíveis para os hóspedes',
    noMobilityServices: 'Nenhum serviço de mobilidade configurado',
    tabTransferOverview: 'Transfers',
    transferOverview: 'Visão Geral de Transfers',
    unassigned: 'Não atribuído',
    reassign: 'Reatribuir',
    tabServiceProviders: 'Prestadores de Serviços',
    tabServiceRequests: 'Pedidos de Serviço',
    serviceProviders: 'Prestadores de Serviços',
    serviceProvidersDesc: 'Gere fornecedores que prestam serviços de mobilidade e transfer',
    addProvider: 'Adicionar Fornecedor',
    noProviders: 'Nenhum fornecedor registado',
    selectUser: 'Selecionar Utilizador',
    selectService: 'Selecionar Serviço',
    maxCapacity: 'Capacidade Máxima',
    serviceRequests: 'Pedidos de Serviço',
    serviceRequestsDesc: 'Visão geral de todos os pedidos de serviço das reservas',
    noServiceRequests: 'Nenhum pedido de serviço',
    // Mobility sub-tab extras
    tabMobilityOverview: 'Visão Geral',
    mobilityOverview: 'Visão Geral de Mobilidade',
    mobilityOverviewDesc: 'Estatísticas globais de fornecedores e pedidos de serviço',
    mobilityProvidersTotal: 'Total de fornecedores',
    mobilityProvidersActive: 'Fornecedores ativos',
    mobilityProvidersInactive: 'Fornecedores inativos',
    mobilityRequestsTotal: 'Total de pedidos',
    mobilityTopProviders: 'Top 5 fornecedores (pedidos concluídos)',
    mobilityNoTopProviders: 'Nenhum fornecedor concluiu pedidos ainda',
    mobilityRefresh: 'Atualizar',
    mobilityLoadError: 'Falha ao carregar dados de mobilidade',
    mobilityOpenSpDashboard: 'Abrir painel do PS',
    mobilityPendingBadge: '{count} pendentes',
    mobilityStatusActive: 'Ativo',
    mobilityStatusInactive: 'Inativo',
    mobilityEditName: 'Nome',
    mobilityEditPrice: 'Preço (€)',
    mobilityEditPriceType: 'Tipo de preço',
    mobilityEditDescription: 'Descrição',
    mobilityEnable: 'Ativar',
    mobilityDisable: 'Desativar',
    mobilityLabelCapacity: 'Cap.',
    mobilityLabelProvider: 'Fornecedor',
    mobilityLabelQuantity: 'Qtd',
    mobilityToggleError: 'Não foi possível atualizar o estado do serviço',
    mobilitySaveError: 'Não foi possível guardar as alterações',
    mobilityLoadProvidersError: 'Não foi possível carregar os fornecedores',
    mobilityLoadRequestsError: 'Não foi possível carregar os pedidos',
    // External services moderation
    externalServicesTitle: 'Serviços Externos',
    externalServicesDesc: 'Modera e gere serviços criados por Prestadores de Serviços',
    externalServicesPending: 'Aprovação pendente',
    externalServicesApprove: 'Aprovar',
    externalServicesReject: 'Rejeitar',
    externalServicesRejectReason: 'Motivo da rejeição',
    externalServicesNotes: 'Notas (visíveis ao PS)',
    externalServiceCreator: 'Criado por',
    externalServiceCreatorAdmin: 'Admin (plataforma)',
    externalServicePorts: 'Portos de operação',
    externalServiceNoPort: 'Nenhum porto associado',
    // Price type labels
    priceType_per_stay: 'Por aluguer',
    priceType_per_day: 'Por dia',
    priceType_per_night: 'Por noite',
    priceType_per_person: 'Por pessoa',
    priceType_per_person_per_day: 'Por pessoa/dia',
    priceType_per_person_per_night: 'Por pessoa/noite',
    confirmDelete: 'Tens a certeza de que queres eliminar?',
    tabPoi: 'Pontos de Interesse',
    tabPorts: 'Portos',
    promoTitle: 'Título',
    promoSubtitle: 'Subtítulo',
    promoDescription: 'Descrição',
    promoImage: 'Imagem',
    promoCtaText: 'Texto do CTA',
    promoCtaLink: 'Link do CTA',
    promoBadge: 'Emblema',
    promoStartDate: 'Data de Início',
    promoEndDate: 'Data de Fim',
    promoActive: 'Ativa',
    promoOrder: 'Ordem',
    promoNew: 'Nova Promoção',
    promoEdit: 'Editar Promoção',
    promoDelete: 'Eliminar Promoção',
    promoDeleteConfirm: 'Tens a certeza de que queres eliminar esta promoção?',
    promoCreated: 'Promoção criada com sucesso',
    promoUpdated: 'Promoção atualizada com sucesso',
    promoDeleted: 'Promoção eliminada com sucesso',
    promoNoResults: 'Nenhuma promoção encontrada',
    promoAlwaysVisible: 'Sempre visível',
    promoSave: 'Guardar',
    promoCancel: 'Cancelar',
    promoUploadImage: 'Carregar imagem',
    promoOrImageUrl: 'ou introduz o URL da imagem',
    promoToggleActive: 'Alternar Ativa',
    promoReorderHint: 'Usa as setas para reordenar',
    promoMoveUp: 'Mover para cima',
    promoMoveDown: 'Mover para baixo',

    // Trends tab
    tabTrends: 'Tendências',
    trendsTotalRevenue: 'Receita do Período',
    trendsMonthlyAvg: 'Média Mensal',
    trendsPerMonth: 'por mês',
    trendsTrend: 'Tendência',
    trendsVsPrev: 'vs período anterior',
    trendsBookings: 'Reservas',
    trendsRevenue: 'Receita',

    // Recent bookings table
    recentBookings: 'Reservas Recentes',
    tableDate: 'Data',
    tableBoat: 'Barco',
    tablePickupReturn: 'Levantamento/Devolução',
    tableValue: 'Valor',
    tableStatus: 'Estado',
    noBookingsYet: 'Ainda sem reservas',
    clientProfile: 'Perfil do Cliente',
    bookingHistory: 'Histórico de Reservas',
    totalSpent: 'Total Gasto',
    cancellationReason: 'Motivo do cancelamento',
    confirmBooking: 'Confirmar reserva',
    cancelBooking: 'Cancelar reserva',
    completeBooking: 'Concluir reserva',
    refundDeposit: 'Reembolsar caução',
    depositRefunded: 'Caução reembolsada',

    // Boats table
    tableVessel: 'Embarcação',
    tablePort: 'Porto',
    tableRate: 'Tarifa',
    tableActions: 'Ações',

    // Bookings table
    tableClients: 'Clientes',
    tablePeriod: 'Período',
    tableTotal: 'Total',
    tablePaymentStatus: 'Pagamento',
    vendorSuspended: 'Vendedor suspenso',
    vendorBookingsSuspended: 'Reservas suspensas',
    boatName: 'Barco',
    email: 'Email',
    embarkation: 'Embarque',
    disembarkation: 'Desembarque',
    deposit: 'Caução',

    // Booking list/calendar view
    allStatuses: 'Todos',
    allPaymentStatuses: 'Todos os pagamentos',
    paymentPending: 'Por pagar',
    paymentPaid: 'Pago',
    paymentPartial: 'Parcial',
    paymentRefunded: 'Reembolsado',
    calendarView: 'Calendário',
    listView: 'Lista',
    searchGuest: 'Pesquisar cliente...',
    cancelWithReason: 'Cancelar com motivo',
    cancelConfirmMessage: 'Tens a certeza de que queres cancelar esta reserva?',
    cancelReasonPlaceholder: 'Motivo do cancelamento (opcional)',

    // Summary cards
    pendingBookings: 'Pendentes',
    confirmedRevenue: 'Receita Confirmada',

    // Booking detail modal
    bookingDetail: 'Detalhe da Reserva',
    guestInfo: 'Informações do Cliente',
    firstName: 'Nome',
    boatInfo: 'Informações do Barco',
    port: 'Porto',
    rentalDetails: 'Detalhes do Aluguer',
    experienceDetails: 'Detalhes da experiência',
    priceSummary: 'Resumo do Preço',
    basePrice: 'Preço base',
    insuranceFee: 'Seguro',
    extras: 'Extras',
    specialRequests: 'Pedidos Especiais',
    downloadReceipt: 'Recibo',
    noBookingsFound: 'Nenhuma reserva encontrada',

    // Reversible bookings
    reversibleBookings: 'Reservas Reversíveis',
    reversibleBookingsSubtitle: 'Podes restaurar o estado anterior',
    reverse: 'Restaurar',
    undo: 'Anular',

    // Calendar overview
    boatsOverview: 'Visão Geral dos Barcos',
    confirmedShort: 'confirmadas',
    pendingShort: 'pendentes',
    blockedShort: 'bloqueadas',

    // Services section
    includedServices: 'Equipamento a Bordo',
    includedServicesSubtitle: 'Gere o equipamento incluído nos barcos',
    addEquipment: 'Adicionar Equipamento',
    extraServices: 'Serviços Extra (Pagos)',
    extraServicesSubtitle: 'Gere os serviços extra que podem ser adicionados aos aluguers. O preço é definido individualmente para cada barco.',
    addExtraService: 'Adicionar Serviço Extra',

    // Extras approval (admin)
    extraFilterAll: 'Todos',
    extraFilterPlatform: 'Plataforma',
    extraFilterVendors: 'Vendedor',
    extraFilterPending: 'Pendentes',
    extraCreatorPlatform: 'Plataforma',
    extraCreatorLabel: 'Criado por',
    extraApprove: 'Aprovar',
    extraReject: 'Rejeitar',
    extraRejectNotes: 'Motivo da rejeição',
    extraRejectNotesPlaceholder: 'Explica o motivo da rejeição...',
    extraPendingCount: 'extras pendentes',
    extraApproved: 'Extra aprovado',
    extraRejected: 'Extra rejeitado',
    extraApproveError: 'Erro ao aprovar',
    extraRejectError: 'Erro ao rejeitar',
    extraPromote: 'Tornar global',
    extraPromoted: 'Extra promovido a serviço global da plataforma',
    extraPromoteError: 'Erro ao promover',
    extraPromoteConfirm: 'Tornar este extra disponível para todos os barcos da plataforma? O vendedor perderá a propriedade exclusiva.',

    // Audit History
    auditTitle: 'Histórico de Operações',
    auditSubtitle: 'Histórico completo das operações de serviços extra para rastreabilidade e resolução de litígios',
    auditTotalEntries: 'operações registadas',
    auditNoEntries: 'Nenhuma operação registada',
    auditDetails: 'Detalhes da operação',
    auditPage: 'Página',

    tableService: 'Serviço',
    tableDescription: 'Descrição',
    tableIcon: 'Ícone',

    // Boat modal
    modalNewBoat: 'Novo Barco InsulaCharter',
    modalEditBoat: 'Editar Barco InsulaCharter',
    formBoatName: 'Nome do Barco',
    formBoatNamePlaceholder: 'ex.: Azzurra',
    formPort: 'Porto Base',
    formPortPlaceholder: 'ex.: Porto Cervo',
    formPricePerDay: 'Preço Diário (€)',
    formInsuranceFee: 'Seguro (€)',
    formDescription: 'Descrição',
    formDescriptionPlaceholder: 'Descreve as características deste barco...',

    // Photos section
    photosSection: 'Fotos do Barco',
    photoCover: 'Capa',
    photoSetCover: 'Definir como Capa',
    addPhoto: 'Adicionar Foto',
    addPhotoMaxReached: 'Adicionar Foto (Máximo atingido)',

    // Specifications
    specifications: 'Especificações Técnicas',
    formLength: 'Comprimento (m)',
    formBeam: 'Boca (m)',
    formCapacity: 'Capacidade de Passageiros',
    formEngine: 'Motor',
    formLicenseRequired: 'Requer Carta Náutica',

    // Services in boat
    onboardEquipment: 'Equipamento a Bordo',
    extraServicesPaid: 'Serviços Extra (pagos)',
    extraServicesCustomPrice: 'Define preços personalizados para este barco',

    // Buttons
    saveChanges: 'Guardar Alterações',
    createListing: 'Publicar Barco',

    // Equipment modal
    modalNewEquipment: 'Novo Equipamento',
    modalEditEquipment: 'Editar Equipamento',
    formServiceId: 'ID do Serviço',
    formServiceIdPlaceholder: 'ex.: bimini_top',
    formServiceIdHelper: 'Usa apenas letras minúsculas e sublinhados',
    formServiceName: 'Nome do Serviço',
    formServiceNamePlaceholder: 'ex.: Bimini Top',
    formServiceDescriptionPlaceholder: 'Descreve o equipamento...',
    formIconOptional: 'Ícone (opcional)',
    iconDefault: 'Info (predefinido)',
    iconAnchor: 'Âncora',
    iconLifeBuoy: 'Bóia Salva-vidas',
    iconCompass: 'Bússola',
    iconSun: 'Sol',
    iconWaves: 'Ondas',
    iconWind: 'Vento',
    iconFuel: 'Combustível',
    iconRadio: 'Rádio',
    iconGps: 'GPS',

    // Extra modal
    modalNewExtra: 'Novo Serviço Extra',
    modalEditExtra: 'Editar Serviço Extra',
    formExtraIdPlaceholder: 'ex.: skipper_service',
    formExtraNamePlaceholder: 'ex.: Skipper Profissional',
    formExtraDescriptionPlaceholder: 'Descreve o serviço extra...',
    extraPriceInfo: 'O preço do serviço será definido individualmente para cada barco.',

    // Multilingual translations
    translationsSection: 'Traduções',
    translationsHelper: 'Introduz as traduções para cada idioma suportado',
    translationsHelperAuto: 'Introduz o texto em italiano e clica em "Traduzir Automaticamente" para gerar as outras traduções.',
    autoTranslate: 'Traduzir Automaticamente',
    translating: 'A traduzir...',
    translationComplete: 'Tradução concluída!',
    translationFailed: 'Erro de tradução',
    enterItalianFirst: 'Introduz primeiro o texto em italiano',
    sourceLang: 'Idioma de origem',
    labelIT: 'Nome (Italiano)',
    labelEN: 'Nome (Inglês)',
    labelDE: 'Nome (Alemão)',
    descriptionIT: 'Descrição (Italiano)',
    descriptionEN: 'Descrição (Inglês)',
    descriptionDE: 'Descrição (Alemão)',
    langIT: 'Italiano',
    langEN: 'Inglês',
    langDE: 'Alemão',

    // Category options
    formCategory: 'Categoria',
    categoryGeneral: 'Serviço geral',
    categorySafety: 'Segurança',
    categoryComfort: 'Conforto',
    categoryNavigation: 'Navegação',
    categoryEntertainment: 'Entretenimento',
    categorySpecial: 'Serviço especial (emblema verde)',

    // Blocked Dates
    allBoats: 'Todos os barcos',
    blockDates: 'Bloquear Datas',
    blockDatesTitle: 'Bloquear Datas',
    blockedPeriods: 'Períodos Bloqueados',
    blocked: 'bloqueado',
    unblock: 'Desbloquear',
    blockingFor: 'A bloquear datas para',
    startDate: 'Data de início',
    endDate: 'Data de fim',
    blockReason: 'Motivo (opcional)',
    blockReasonPlaceholder: 'ex.: Manutenção, Uso pessoal...',
    blockWarning: 'As datas bloqueadas não estarão disponíveis para novos aluguers e serão mostradas como "indisponíveis" aos utilizadores.',
    confirmBlock: 'Bloquear Datas',
    selectBoatFirst: 'Seleciona primeiro um barco',
    selectDatesFirst: 'Seleciona as datas',
    datesBlocked: 'Datas bloqueadas com sucesso',
    datesUnblocked: 'Datas desbloqueadas',
    confirmUnblock: 'Queres desbloquear estas datas?',
    tabSettings: 'Definições',
    tabClients: 'Clientes',
    tabClientManagement: 'Clientes',

    // Clients section
    clientsTitle: 'Gestão de Clientes',
    searchClients: 'Pesquisar por nome ou email...',
    searchBookings: 'Pesquisar cliente, email...',
    noClients: 'Nenhum cliente registado',
    tableClient: 'Cliente',
    tableEmail: 'Email',
    tableBookingsCount: 'Reservas',
    tableTotalSpent: 'Total Gasto',
    tableRegistered: 'Registado em',
    registeredOn: 'Registado em',
    totalBookings: 'Total',
    viewClient: 'Ver Cliente',
    clientConfirmedBookings: 'Confirmadas',
    clientPendingBookings: 'Pendentes',
    clientCancelledBookings: 'Canceladas',
    emailVerified: 'Email Verificado',
    emailNotVerified: 'Email Não Verificado',

    // Admin User Management
    userManagement: 'Gestão Avançada',
    userManagementDesc: 'Ações administrativas para este utilizador',
    resetEmailVerification: 'Repor Verificação de Email',
    resetEmailVerificationDesc: 'Repõe o estado de verificação do email. O utilizador terá de verificar o seu email novamente.',
    resetEmailVerificationSuccess: 'Verificação de email reposta com sucesso',
    resetPassword: 'Repor Palavra-passe',
    resetPasswordDesc: 'Envia um email de reposição de palavra-passe ao utilizador.',
    resetPasswordSuccess: 'Email de reposição de palavra-passe enviado',
    resetPasswordEmailFailed: 'Não foi possível enviar o email. Token gerado para uso manual.',
    emailNotConfigured: 'Email não configurado. Token gerado para uso manual.',
    userNotFound: 'Utilizador não encontrado',
    confirmAction: 'Confirmar Ação',
    confirmResetEmailVerification: 'Tens a certeza de que queres repor a verificação de email deste utilizador?',
    confirmResetPassword: 'Tens a certeza de que queres enviar um email de reposição de palavra-passe a este utilizador?',
    // Suspension
    suspendUser: 'Suspender Utilizador',
    suspendUserDesc: 'Bloqueia o acesso à plataforma e impede novas reservas.',
    unsuspendUser: 'Reativar Utilizador',
    unsuspendUserDesc: 'Restaura o acesso total à plataforma.',
    suspendUserSuccess: 'Utilizador suspenso com sucesso',
    unsuspendUserSuccess: 'Utilizador reativado com sucesso',
    confirmSuspendUser: 'Tens a certeza de que queres suspender este utilizador? Ele deixará de poder aceder à plataforma.',
    confirmUnsuspendUser: 'Tens a certeza de que queres reativar este utilizador?',
    suspensionReason: 'Motivo da suspensão',
    suspensionReasonPlaceholder: 'Ex.: Violação dos termos de serviço, pagamentos fraudulentos...',
    suspended: 'Suspenso',
    suspendedSince: 'Suspenso desde',
    accountSuspended: 'Conta Suspensa',
    accountSuspendedDesc: 'A tua conta foi suspensa. Contacta o suporte para mais informações.',
    suspendCompanyDesc: 'Bloqueia o acesso à plataforma, impede novas reservas e oculta os barcos do catálogo.',

    // Monitoring / Logs
    tabMonitoring: 'Monitorização',
    tabLogs: 'Registos de Eventos',
    tabRawConsole: 'Consola bruta',
    logs: {
      title: 'Registos do Sistema',
      description: 'Registo de eventos e atividade da plataforma',
      filterCategory: 'Categoria',
      filterLevel: 'Nível',
      filterFrom: 'De',
      filterTo: 'Até',
      filterSearch: 'Pesquisar na mensagem...',
      filterActor: 'Utilizador (ID)',
      reset: 'Repor',
      exportCsv: 'Exportar CSV',
      columns: {
        timestamp: 'Data',
        level: 'Nível',
        category: 'Categoria',
        action: 'Ação',
        actor: 'Utilizador',
        target: 'Alvo',
        message: 'Mensagem',
        ip: 'IP',
        details: 'Detalhes',
      },
      detailsTitle: 'Detalhes do evento',
      metadata: 'Metadados',
      requestId: 'ID do Pedido',
      empty: 'Nenhum evento',
      loading: 'A carregar registos...',
      page: 'Página {{n}} de {{total}}',
      levels: {
        all: 'Todos',
        info: 'Info',
        warn: 'Aviso',
        error: 'Erro',
      },
      categories: {
        all: 'Todas',
        auth: 'Autenticação',
        ambassador: 'Embaixador',
        booking: 'Reservas',
        payment: 'Pagamentos',
        admin: 'Admin',
        system: 'Sistema',
        http: 'HTTP',
      },
    },

    bookings: {
      actionCancel: 'Cancelar',
      actionHardDelete: 'Eliminar permanentemente',
      paymentMethod: 'Método de pagamento',
      amountPaid: 'Valor pago',
      confirmCancel: 'Confirmar cancelamento',

      hardDeleteTitle: 'Eliminação permanente',
      hardDeleteWarningTitle: 'ELIMINAÇÃO PERMANENTE — IRREVERSÍVEL',
      hardDeleteWarning: 'Esta operação elimina a reserva da base de dados para sempre. Usa apenas para dados de teste, nunca em produção.',
      hardDeleteConfirmType: 'Para confirmar, escreve "{keyword}"',
      hardDeleteConfirm: 'Eliminar permanentemente',

      cancelRefundTitle: 'Cancelar reserva e reembolsar',
      refundPreview: 'Valor do reembolso',
      refundPolicy: 'Política aplicada',
      refundViaMollie: 'Reembolsar automaticamente via Mollie',
      refundViaMollieDesc: 'A Mollie processa o reembolso no mesmo cartão utilizado pelo cliente.',
      refundManualWarningTitle: 'Reembolso manual necessário',
      refundManualWarning: 'Pagamento via {gateway}: após o cancelamento tens de marcar manualmente o reembolso como concluído a partir do detalhe da reserva.',
      refundPendingBox: 'Reembolso manual necessário',
      markRefunded: 'Marcar como reembolsado',
      waiveRefund: 'Renunciar ao reembolso',
      refundNote: 'Nota (opcional)',
      refundNotePlaceholder: 'Motivo do cancelamento ou nota interna...',

      statusRefundPending: 'Reembolso pendente',
      statusRefundProcessing: 'Reembolso em processamento',
      statusRefundFailed: 'Reembolso falhado',
      statusRefundWaived: 'Reembolso dispensado',

      toastCancelSuccess: 'Reserva cancelada',
      toastRefundedMollie: 'Reembolsado via Mollie',
      toastRefundPending: 'Cancelada. Reembolso manual pendente',
      toastRefundProcessing: 'Cancelada. Reembolso em processamento',
      toastRefundFailed: 'Reembolso Mollie falhou — tenta novamente manualmente',
      toastDeleted: 'Reserva eliminada permanentemente',
      toastMarkedRefunded: 'Reserva marcada como reembolsada',
      toastRefundWaived: 'Renúncia ao reembolso registada',

      forceRefundTitle: 'Reembolso Mollie não registado',
      forceRefundDesc: 'Esta reserva foi cancelada mas o reembolso via Mollie nunca foi executado. Podes forçá-lo manualmente agora.',
      forceRefundPaid: 'Valor pago',
      forceRefundAmount: 'Valor a reembolsar',
      forceRefundBtn: 'Forçar reembolso Mollie',
      forceRefundConfirm: 'Confirmar um reembolso de €{amount} na Mollie?',
      forceRefundSuccess: 'Reembolso processado na Mollie (€{amount})',
      forceRefundError: 'Reembolso falhou',
      forceRefundMollieId: 'ID do pagamento Mollie',
    },

    settings: {
      securityTitle: 'Segurança e Testes',
      securityDesc: 'Operações destrutivas e funcionalidades exclusivas de teste',
      hardDeleteToggle: 'Permitir eliminação permanente de reservas',
      hardDeleteDescription: 'Apenas ambientes de teste. Se ativado, os administradores podem eliminar reservas permanentemente da base de dados. Mantém DESATIVADO em produção.',
      hardDeleteOn: 'LIGADO',
      hardDeleteOff: 'DESLIGADO',
      hardDeleteWarningProd: 'AVISO: esta opção deve permanecer DESATIVADA em produção. As eliminações são irreversíveis e removem dados históricos de pagamentos, recibos e registos de auditoria.',
    },
  },

  // ============================================
  // SETTINGS
  // ============================================
  settings: {
    title: 'Configuração',
    subtitle: 'Gere as definições do sistema',
    saved: 'Definição guardada',
    invalidDays: 'Introduz um valor entre 1 e 90',

    // Dashboard Layout
    dashboardLayout: 'Disposição do Painel',
    dashboardLayoutDesc: 'Escolhe como agrupar os separadores nos painéis de admin e de vendedor',
    layoutAdmin: 'Painel de Administração',
    layoutVendor: 'Painel do Vendedor',
    layoutA: 'Compacto',
    layoutADesc: 'Agrupa os separadores em poucas macro secções',
    layoutB: 'Prioridade operacional',
    layoutBDesc: 'Equilíbrio entre visibilidade e agrupamento',
    layoutC: 'Ultra-compacto',
    layoutCDesc: 'Número mínimo de separadores principais',
    layoutTabs: 'separadores',
    layoutCurrent: 'Atual',

    // Admin tab group labels
    layoutAdminFleet: 'Frota',
    layoutAdminOperations: 'Operações',
    layoutAdminClientsServices: 'Clientes e Serviços',
    layoutAdminMarketplace: 'Marketplace',
    layoutAdminFinance: 'Finanças',
    layoutAdminManagement: 'Gestão',

    // Vendor tab group labels
    layoutVendorFleet: 'Frota',
    layoutVendorOperations: 'Operações',
    layoutVendorServicesClients: 'Serviços e Clientes',
    layoutVendorManagement: 'Gestão',

    // Sub-tab labels
    subtabStats: 'Estatísticas',
    subtabVendors: 'Vendedores',
    subtabBoatApproval: 'Aprovação de Barcos',
    subtabRevenue: 'Receita',
    subtabPayouts: 'Pagamentos',
    subtabPlatformStats: 'Plataforma',
    autoCancellation: 'Cancelamento Automático de Reservas Pendentes',
    autoCancellationDesc: 'Quando ativado, as reservas em estado "Pendente" serão canceladas automaticamente após o número de dias especificado.',
    enableAutoCancel: 'Ativar cancelamento automático',
    autoCancelEnabled: 'As reservas pendentes expiradas serão canceladas automaticamente',
    autoCancelDisabled: 'As reservas pendentes não serão canceladas automaticamente',
    daysBeforeCancel: 'Dias antes do cancelamento',
    daysBeforeCancelDesc: 'Número de dias após os quais uma reserva pendente é cancelada (1-90)',
    howItWorks: 'Como funciona',
    howItWorksDesc: 'O sistema verifica todos os dias à meia-noite as reservas em estado "Pendente" (PENDING). Se uma reserva foi criada há mais do que o número de dias especificado e ainda não foi confirmada, é cancelada automaticamente com o motivo "Expiração automática".',

  },

  // ============================================
  // AUTH - LOGIN
  // ============================================
  login: {
    title: 'Bem-vindo de Volta',
    subtitle: 'Inicia sessão na tua conta',
    emailLabel: 'Email',
    emailPlaceholder: 'oteu@email.com',
    passwordLabel: 'Palavra-passe',
    passwordPlaceholder: '••••••••',
    submitButton: 'Iniciar Sessão',
    submittingButton: 'A iniciar sessão...',
    noAccount: 'Não tens conta? Regista-te',
    partnerRedirect: 'Os parceiros devem iniciar sessão em partner.insulacharter.it',
    testAccounts: 'Contas de teste:',
    testGuest: 'Convidado: turista@example.com',
    testAdmin: 'Admin: info@insulacharter.it',
    testPassword: 'Palavra-passe: InsulaHost2026!',
    forgotPassword: 'Esqueceste-te da palavra-passe?',
  },

  // ============================================
  // AUTH - FORGOT PASSWORD
  // ============================================
  forgotPassword: {
    title: 'Esqueceste-te da palavra-passe',
    description: 'Introduz o teu email e enviaremos um link para repores a tua palavra-passe.',
    submitButton: 'Enviar link de reposição',
    emailSentTitle: 'Email enviado!',
    emailSentDescription: 'Se o email estiver registado, receberás um link para repores a tua palavra-passe. Verifica também a pasta de spam.',
    backToLogin: 'Voltar ao início de sessão',
  },

  // ============================================
  // AUTH - RESET PASSWORD
  // ============================================
  resetPassword: {
    title: 'Nova palavra-passe',
    description: 'Escolhe uma nova palavra-passe para a tua conta.',
    newPasswordLabel: 'Nova palavra-passe',
    newPasswordPlaceholder: 'Introduz a tua nova palavra-passe',
    confirmPasswordLabel: 'Confirmar palavra-passe',
    confirmPasswordPlaceholder: 'Repete a tua nova palavra-passe',
    submitButton: 'Repor palavra-passe',
    successTitle: 'Palavra-passe reposta!',
    successDescription: 'A tua palavra-passe foi atualizada. Serás redirecionado para o início de sessão...',
    invalidLink: 'Link inválido',
    invalidLinkDescription: 'O link de reposição está em falta ou é inválido. Solicita um novo link.',
    requestNewLink: 'Solicitar novo link',
    passwordMismatch: 'As palavras-passe não coincidem',
  },

  // ============================================
  // AUTH - PARTNER LOGIN
  // ============================================
  partnerLogin: {
    title: 'Portal de Parceiros',
    subtitle: 'InsulaCharter — Área Reservada',
    sectionLabel: 'Início de Sessão de Parceiro',
    emailPlaceholder: 'email@example.com',
    submit: 'Iniciar Sessão',
    submitting: 'A iniciar sessão...',
    accessDenied: 'Esta área é reservada a parceiros. Inicia sessão a partir do site principal.',
    copyright: 'Todos os direitos reservados.',
  },

  // ============================================
  // PARTNER PROFILE (completion)
  // ============================================
  partnerProfile: {
    tab: { anagrafica: 'Dados', documenti: 'Documentos', account: 'Conta' },
    header: { verified: 'Verificado', pending: 'Pendente', ibanMissing: 'IBAN não definido', manageIban: 'Definições' },
    role: { VENDOR: 'Operador', COMPANY: 'Empresa', ADMIN: 'Admin' },
    completionTitle: 'Conclusão do perfil',
    missing: 'Em falta',
    allDone: 'Perfil completo',
    loading: 'A carregar perfil…',
    loadError: 'Erro ao carregar o perfil',
    saved: 'Perfil atualizado',
    saveError: 'Erro ao guardar',
    notSet: 'Não definido',
    managePayout: 'Gerir em Definições → Pagamentos e Transferências',
    save: 'Guardar perfil',
    saving: 'A guardar…',
    badgeComplete: 'Completo',
    badgeMissingOne: 'em falta',
    badgeMissingMany: 'em falta',
    bioPlaceholder: 'Descreve o teu negócio (mín. 30 caracteres)…',
    bioHelper: 'Pelo menos 30 caracteres.',
    seasonHint: 'Padrão para toda a frota. Deixa em branco para "sempre aberto".',
    seasonFrom: 'De',
    seasonTo: 'Até',
    docsHint: 'Os documentos são verificados pela equipa InsulaCharter.',
    docsUpload: 'Carregar',
    docsReplace: 'Substituir',
    docStatusMissing: 'Por carregar',
    docStatusPending: 'Em análise',
    docStatusApproved: 'Verificado',
    docStatusRejected: 'Rejeitado',
    docUploadError: 'Erro ao carregar',
    docUploadOk: 'Documento carregado',
    emailVerifyTitle: 'Verificação de email',
    changePassword: 'Alterar palavra-passe',
    currentPassword: 'Palavra-passe atual',
    newPassword: 'Nova palavra-passe',
    confirmPassword: 'Confirmar nova palavra-passe',
    pwUpdate: 'Atualizar palavra-passe',
    pwUpdating: 'A atualizar…',
    pwMismatch: 'As novas palavras-passe não coincidem',
    pwTooShort: 'A nova palavra-passe deve ter pelo menos 8 caracteres',
    pwUpdated: 'Palavra-passe atualizada',
    pwError: 'Erro ao alterar a palavra-passe',
    forgotTitle: 'Esqueceste-te da palavra-passe?',
    forgotDesc: 'Recebe um link por email para repores a tua palavra-passe.',
    forgotCta: 'Repor palavra-passe →',
    suspendedOk: 'Reservas suspensas',
    reactivatedOk: 'Reservas reativadas',
    section: {
      company: 'Dados da empresa',
      address: 'Morada da sede',
      personal: 'Dados pessoais',
      payout: 'Dados de pagamento',
      presentation: 'Apresentação',
      documents: 'Documentos da empresa',
      season: 'Época de reservas',
      account: 'Conta e segurança',
    },
    field: {
      company_name: 'Nome da empresa',
      company_vat: 'Número de IVA',
      company_pec: 'Correio eletrónico certificado (PEC)',
      company_sdi: 'Código SDI',
      vendor_phone: 'Telefone',
      address_street: 'Morada',
      address_city: 'Cidade',
      address_province: 'Província',
      address_postal_code: 'Código postal',
      payout_iban: 'IBAN',
      payout_holder: 'Titular da conta',
      vendor_bio: 'Biografia / descrição',
      email_verified: 'Email verificado',
      name: 'Nome',
      email: 'Email',
      BUSINESS_REGISTRATION: 'Registo comercial',
      VAT_CERTIFICATE: 'Certificado de IVA',
      INSURANCE: 'Seguro de responsabilidade civil',
    },
  },

  // BOOKING SUSPENDED OVERLAY
  // ============================================
  suspended: {
    title: 'Reservas temporariamente suspensas',
    description: 'Estamos a atualizar o nosso sistema de reservas. Deixa o teu email e avisamos-te assim que as reservas reabrirem.',
    notifyLabel: 'Queres ser notificado?',
    emailPlaceholder: 'O teu email',
    notifyBtn: 'Notificar-me quando disponível',
    sending: 'A enviar...',
    error: 'Ocorreu um erro. Tenta novamente.',
    vendorTitle: 'Reservas do parceiro suspensas',
    vendorDescription: 'Este parceiro suspendeu temporariamente as reservas para os seus barcos.',
    boatTitle: 'Reservas do barco suspensas',
    boatDescription: 'As reservas para este barco estão temporariamente suspensas.',
    suspendVendorBookings: 'Suspender reservas do parceiro',
    unsuspendVendorBookings: 'Retomar reservas do parceiro',
    suspendVendorBookingsDesc: 'Bloqueia as reservas para todos os barcos deste parceiro.',
    suspendMyBookings: 'Pausar as minhas reservas',
    unsuspendMyBookings: 'Retomar as minhas reservas',
    suspendMyBookingsDesc: 'Pausa as reservas para todos os teus barcos (ex.: período de férias).',
    suspendBoatBookings: 'Suspender reservas',
    unsuspendBoatBookings: 'Retomar reservas',
    byAdmin: 'Suspenso pelo administrador',
  },

  // ============================================
  // COOKIE CONSENT
  // ============================================
  cookie: {
    title: 'Privacidade a Bordo',
    description: 'Utilizamos cookies para te proporcionar uma experiência de navegação otimizada e personalizar os teus próximos itinerários na Sardenha.',
    acceptAll: 'Aceitar Tudo',
    decline: 'Recusar',
    advancedPrefs: 'Preferências Avançadas',
    savePrefs: 'Guardar Preferências',
    alwaysActive: 'sempre ativo',
    necessary: 'Necessários',
    necessaryDesc: 'Cookies essenciais para o funcionamento do site. Não podem ser desativados.',
    analytics: 'Análise',
    analyticsDesc: 'Ajudam-nos a perceber como usas o site para melhorar a tua experiência.',
    marketing: 'Marketing',
    marketingDesc: 'Usados para te mostrar ofertas e promoções relevantes.',
    preferences: 'Preferências',
    preferencesDesc: 'Recordam as tuas escolhas, como o idioma e a área de navegação.',
  },

  // ============================================
  // AUTH - REGISTER
  // ============================================
  register: {
    title: 'Criar Conta',
    subtitle: 'Começa a tua aventura no mar',
    nameLabel: 'Nome Completo',
    namePlaceholder: 'João Silva',
    emailLabel: 'Email',
    emailPlaceholder: 'oteu@email.com',
    passwordLabel: 'Palavra-passe',
    passwordPlaceholder: '••••••••',
    passwordHelper: 'Mín. 8 caracteres, maiúscula, minúscula, número, carácter especial',
    confirmPasswordLabel: 'Confirmar Palavra-passe',
    passwordMismatch: 'As palavras-passe não coincidem',
    submitButton: 'Registar',
    submittingButton: 'A registar...',
    hasAccount: 'Já tens conta? Inicia sessão',
    // Role selection
    roleLabel: 'Tipo de conta',
    roleGuest: 'Turista',
    roleGuestDesc: 'Reserva barcos e serviços',
    roleVendor: 'Proprietário',
    roleVendorDesc: 'Aluga o teu barco',
    roleAgency: 'Agência',
    roleAgencyDesc: 'Revende barcos e serviços de empresas',
    roleCompany: 'Empresa',
    roleCompanyDesc: 'Gere uma frota de barcos',
    roleServiceProvider: 'Prestador de Serviços',
    roleServiceProviderDesc: 'Oferece serviços a barcos e clientes',
    roleServiceProviderDisabled: 'Apenas por convite',
    roleExcursion: 'Operador de Excursões',
    roleExcursionDesc: 'Snorkeling, tours, trekking — apenas excursões',
    providesExcursionsLabel: 'Também ofereço excursões guiadas',
    providesExcursionsHelp: 'Marca esta opção se a tua empresa faz charter e excursões: terás acesso a ambos os painéis.',
    companyTypeTitle: 'O que faz a tua empresa?',
    companyTypeSubtitle: 'Escolhe o tipo de atividade para ativar as funcionalidades corretas',
    serviceTypeTitle: 'O que ofereces?',
    serviceTypeSubtitle: 'Escolhe todos os serviços que ofereces (podes selecionar mais do que um)',
    art49Title: 'És um particular: charter ocasional (art. 49-bis)',
    art49Intro: 'Como particular sem número de IVA, podes alugar ou fretar o teu barco ocasionalmente. Pontos-chave:',
    art49P1: 'Até 42 dias por ano no total (aluguer, excursões e experiências).',
    art49P2: 'Regime fiscal favorável: imposto substitutivo fixo de 20% sobre os rendimentos (mediante pedido).',
    art49P3: 'Não constitui uma atividade comercial.',
    art49P4: 'Para além do limite é necessário um número de IVA: deves registar-te como Empresa.',
    art49Disclaimer: 'Referência: art. 49-bis do Código da Náutica de Recreio italiano (Decreto Legislativo 171/2005). Informação indicativa, não constitui aconselhamento fiscal.',
    vatLookupCta: 'Obter dados a partir do IVA',
    vatSearching: 'A pesquisar…',
    vatAutofilled: 'Preenchido automaticamente — revê e edita se necessário',
    vatEnterFirst: 'Introduz primeiro o número de IVA',
    vatInvalid: 'Número de IVA inválido',
    vatError: 'Erro na pesquisa',
    vatNetworkError: 'Erro de rede',
    vatLookupHint: 'Introduz o número de IVA e clica em "Obter" para pré-preencher o nome da empresa, PEC e morada (podes editá-los depois).',
    companyTypeCharter: 'Charter / Aluguer de barcos',
    companyTypeCharterDesc: 'Gere uma frota de barcos para aluguer',
    companyTypeExcursion: 'Apenas excursões',
    companyTypeExcursionDesc: 'Snorkeling, tours guiados, trekking, provas — sem aluguer',
    companyTypeMixed: 'Charter + excursões',
    companyTypeMixedDesc: 'Ofereces ambos: acesso a dois painéis a partir da mesma área de parceiro',
    serviceProviderSectionTitle: 'Informações do Fornecedor',
    vendorSectionTitle: 'Informações do Proprietário',
    vendorPhoneLabel: 'Telefone',
    vendorPhonePlaceholder: '+351 91...',
    companySectionTitle: 'Dados da Empresa',
    companyNameLabel: 'Nome da Empresa',
    companyNamePlaceholder: 'Empresa Lda.',
    companyVatLabel: 'Número de IVA',
    companyVatPlaceholder: 'IT12345678901',
    companyPecLabel: 'PEC',
    companySdiLabel: 'Código SDI',
    spSectionTitle: 'Informações do Fornecedor',
    spLicenseLabel: 'Número de Licença',
    spLicensePlaceholder: 'ex. ABC-12345',
    spServiceAreaLabel: 'Área de serviço',
    spServiceAreaPlaceholder: 'ex. Alghero, Sassari...',
    spFleetSizeLabel: 'Número de veículos',
    passwordStrengthWeak: 'Fraca',
    passwordStrengthFair: 'Razoável',
    passwordStrengthGood: 'Boa',
    passwordStrengthStrong: 'Forte',
    pendingApprovalInfo: 'Este tipo de conta requer aprovação da equipa.',
    pendingApprovalTitle: 'Registo Submetido',
    pendingApprovalMessage: 'A tua conta foi criada com sucesso. A nossa equipa irá verificar os teus dados e aprovar o teu perfil.',
    pendingApprovalStep1: '1. Conta criada com sucesso',
    pendingApprovalStep2: '2. A aguardar verificação da equipa',
    pendingApprovalStep3: '3. Receberás uma notificação por email',
    backToHome: 'Voltar ao início',
  },

  // ============================================
  // MAINTENANCE PAGE
  // ============================================
  maintenance: {
    title: 'Site em Manutenção',
    message: 'Estamos a atualizar o site para te oferecer uma melhor experiência. Estaremos de volta em breve.',
    footer: 'InsulaCharter - Aluguer de Barcos na Sardenha',
  },

  // ============================================
  // LANDING PAGE (Pre-launch)
  // ============================================
  landing: {
    title: 'InsulaCharter',
    subtitle: 'Estamos a trabalhar para ti',
    message1: 'O nosso novo site está em desenvolvimento.',
    message2: 'Em breve poderás descobrir os melhores barcos para alugar na Sardenha.',
    needInfo: 'Precisas de informações?',
    devAccess: 'Acesso de desenvolvedor',
    devLoginTitle: 'Acesso de Desenvolvedor',
    devLoginMessage: 'Introduz a palavra-passe para aceder ao site',
    wrongPassword: 'Palavra-passe incorreta',
    copyright: '© 2026 InsulaCharter - Aluguer de Barcos na Sardenha',
  },

  // ============================================
  // TOAST MESSAGES
  // ============================================
  toast: {
    bookingCreated: 'Reserva criada com sucesso!',
    bookingCancelled: 'Reserva cancelada com sucesso!',
    bookingError: 'Erro ao criar a reserva: ',
    boatCreated: 'Barco adicionado com sucesso!',
    boatUpdated: 'Barco atualizado com sucesso!',
    boatDeleted: 'Barco eliminado com sucesso!',
    maxPhotos: 'Podes adicionar um máximo de 10 fotos',
    nameMinLength: 'O nome deve ter pelo menos 3 caracteres',
    descriptionMinLength: 'A descrição deve ter pelo menos 10 caracteres',
    serviceExists: 'Já existe um serviço com este nome',
  },

  // ============================================
  // CONFIRM DIALOGS
  // ============================================
  confirm: {
    cancelBooking: 'Queres cancelar a reserva?',
    deleteBoat: 'Queres mesmo remover este barco da frota InsulaCharter?',
    deleteServiceUsed: 'Este serviço é usado em {count} barcos. Queres eliminá-lo mesmo assim?',
    deleteService: 'Queres eliminar este serviço?',
  },

  // ============================================
  // LANGUAGE SELECTOR
  // ============================================
  language: {
    select: 'Idioma',
    it: 'Italiano',
    en: 'Inglês',
    de: 'Alemão',
  },

  // ============================================
  // CALENDAR
  // ============================================
  calendar: {
    available: 'Disponível',
    booked: 'Reservado',
    pending: 'Pendente',
    blocked: 'Indisponível',
    yourSelection: 'A tua seleção',
    selectDates: 'Seleciona as datas',
    pickupDate: 'Levantamento',
    returnDate: 'Devolução',
    days: 'dias',
    day: 'dia',
    clearSelection: 'Limpar seleção',
    confirmDates: 'Confirmar datas',
    availability: 'Disponibilidade',
    selectPickup: 'Seleciona a data de levantamento',
    selectReturn: 'Seleciona a data de devolução',
    // Booking detail modal
    bookingDetails: 'Detalhes da Reserva',
    boat: 'Barco',
    client: 'Cliente',
    period: 'Período',
    passengers: 'passageiros',
    total: 'Total',
    basePrice: 'Aluguer',
    insuranceFee: 'Seguro',
    extras: 'Extras',
    specialRequests: 'Pedidos especiais',
    createdAt: 'Criado em',
    unavailable: 'Indisponível',
    paymentMethod: 'Método de Pagamento',
  },

  // ============================================
  // ICAL SYNC
  // ============================================
  ical: {
    title: 'Sincronização iCal',
    titleWithBoat: 'Sincronização iCal — {boatName}',
    exportUrl: 'URL de Exportação',
    exportHint: 'Usa este URL para importar o calendário noutras plataformas (Airbnb, Booking.com, MMK Booking Manager, etc.)',
    importedFeeds: 'Feeds Importados',
    addFeed: 'Adicionar Feed',
    feedUrlPlaceholder: 'URL do feed iCal',
    feedLabelPlaceholder: 'Etiqueta (opcional)',
    cancel: 'Cancelar',
    adding: 'A adicionar...',
    add: 'Adicionar',
    noFeeds: 'Nenhum feed importado',
    events: 'eventos',
    error: 'Erro',
    lastSync: 'Última sincronização',
    confirmDelete: 'Eliminar este feed iCal?',
    syncNow: 'Sincronizar agora',
    openFeed: 'Abrir feed',
    deleteFeed: 'Eliminar feed',
    sourceAirbnb: 'Airbnb',
    sourceBooking: 'Booking.com',
    sourceGoogle: 'Google Calendar',
    sourceMmk: 'MMK Booking Manager',
    sourceOther: 'Outro',
    guideTitle: 'Como ligar o teu calendário externo',
    guideStep1: '1. Copia o URL de exportação acima e cola-o na plataforma externa (MMK, Airbnb, etc.) como "calendário externo" ou "feed iCal"',
    guideStep2: '2. Na plataforma externa, copia o URL do calendário da tua embarcação e cola-o abaixo clicando em "Adicionar Feed"',
    guideStep3: '3. A sincronização acontece automaticamente a cada 15 minutos. Podes forçá-la com o botão "Sincronizar agora"',
    boatsTitle: 'Barcos para aluguer',
    excursionsTitle: 'Excursões e experiências',
    excursionsHint: 'Publica as partidas das tuas excursões/experiências em calendários externos (apenas exportação).',
    excursionsEmpty: 'Nenhuma excursão ou experiência',
    copyExportUrl: 'Copiar',
    manageFeeds: 'Gerir feeds',
  },

  // ============================================
  // BOOKING (Bookings)
  // ============================================
  booking: {
    bookingSuspensionToggled: 'Estado de suspensão de reservas atualizado',
    confirmed: 'Confirmada',
    pending: 'Pendente',
    cancelled: 'Cancelada',
    completed: 'Concluída',
    refunded: 'Reembolsada',
    awaitingPayment: 'Pagamento pendente',
    pendingLateBooking: 'A aguardar confirmação',
    payNow: 'Pagar agora',
    startingPayment: 'A iniciar…',
    paymentStartFailed: 'Não foi possível iniciar o pagamento. Tenta novamente.',
    networkErrorRetry: 'Erro de rede. Tenta novamente.',
    modify: 'Modificar',
    cancel: 'Cancelar',
    receipt: 'Recibo',
    paid: 'Pago',
    notPaid: 'Por pagar',
    partiallyPaid: 'Parcial',
    depositPaid: 'Caução paga',
    depositRefunded: 'Caução reembolsada',
    paymentFailed: 'Falhado',
    departurePoint: 'Ponto de partida',
    departurePointRequired: 'Seleciona um ponto de partida',
    departureFrom: 'Partida de',
  },

  // ============================================
  // CANCELLATION REQUEST (customer-driven)
  // ============================================
  cancellation: {
    reasonBadWeather: 'Mau tempo',
    reasonBadWeatherHint: 'Mar agitado, aviso oficial, condições inseguras',
    reasonHealth: 'Motivos de saúde',
    reasonHealthHint: 'Doença ou lesão do titular da reserva',
    reasonEmergency: 'Emergência',
    reasonEmergencyHint: 'Emergência familiar ou profissional grave',
    reasonForceMajeure: 'Força maior',
    reasonForceMajeureHint: 'Eventos incontroláveis (ex.: confinamentos, luto)',
    reasonOther: 'Outro motivo',
    reasonOtherHint: 'Especifica o motivo na descrição',
    requestSentTitle: 'Pedido de cancelamento enviado',
    requestSentDesc: 'O vendedor está a analisar o teu pedido. Receberás uma resposta por email.',
    reasonLabel: 'Motivo:',
    rejectedTitle: 'Pedido não aprovado',
    rejectedDefaultDesc: 'O vendedor rejeitou o pedido de cancelamento.',
    newRequest: 'Enviar um novo pedido',
    approvedTitle: 'Cancelamento aprovado',
    approvedDesc: 'Qualquer reembolso devido será processado através do método de pagamento original.',
    requestCta: 'Solicitar cancelamento',
    formTitle: 'Pedido de cancelamento por justa causa',
    formSubtitle: 'Seleciona um motivo. O vendedor irá analisar o pedido e pode aprová-lo ou rejeitá-lo.',
    description: 'Descrição',
    descriptionPlaceholderOther: 'Explica o motivo do pedido (obrigatório para "Outro")',
    descriptionPlaceholderDefault: 'Adiciona detalhes úteis ao vendedor (opcional)',
    minChars: 'Mínimo 10 caracteres',
    cancel: 'Cancelar',
    sending: 'A enviar…',
    sendRequest: 'Enviar pedido',
    sendFailed: 'Falha ao enviar',
    unknownError: 'Erro desconhecido',
  },

  // ============================================
  // REVIEW FORM
  // ============================================
  review: {
    selectRating: 'Seleciona uma classificação geral.',
    writeComment: 'Escreve um comentário.',
    submitError: 'Erro ao submeter a avaliação.',
    overallRating: 'Classificação geral *',
    titleLabel: 'Título (opcional)',
    titlePlaceholder: 'Resume a tua experiência',
    commentLabel: 'Comentário *',
    commentPlaceholder: 'Conta-nos a tua experiência...',
    detailedRatings: 'Classificações detalhadas (opcional)',
    boatCondition: 'Estado do barco',
    itinerary: 'Itinerário',
    valueForMoney: 'Relação qualidade-preço',
    communication: 'Comunicação',
    sending: 'A enviar...',
    submit: 'Submeter avaliação',
  },

  // ============================================
  // AMBASSADOR (banner + invite codes)
  // ============================================
  ambassador: {
    requestSent: 'Pedido enviado',
    genericError: 'Erro',
    codeCopied: 'Código copiado!',
    copyFailed: 'Não foi possível copiar',
    linkCopied: 'Link copiado!',
    linkCopyFailed: 'Não foi possível copiar o link',
    youAreAmbassador: 'És um Embaixador!',
    commissionPct: '{rate}% de comissão',
    copyCode: 'Copiar código',
    copyInviteLink: 'Copiar link de convite',
    peopleReferred: 'pessoas indicadas',
    viaCode: ' · {used} via código',
    withYourCode: ' com o teu código',
    generateLink: 'Gerar link',
    pendingTitle: 'Pedido de Embaixador pendente',
    pendingDesc: 'A nossa equipa está a analisar o teu pedido',
    rejectedDesc: 'O teu pedido de embaixador não foi aprovado.',
    becomeAmbassador: 'Tornar-me Embaixador',
    becomeAmbassadorDesc: 'Ganha uma comissão por cada utilizador que trouxeres à plataforma',
    sendingRequest: 'A enviar...',
    applyRequest: 'Candidatar-me a Embaixador',
  },

  // ============================================
  // AMBASSADOR CODES MANAGER (multi-code + referrals)
  // ============================================
  ambassadorCodes: {
    roleCustomer: 'Cliente',
    roleAgency: 'Agência',
    roleCollaborator: 'Colaborador',
    roleVendor: 'Vendedor',
    roleCompany: 'Empresa',
    roleAdmin: 'Admin',
    roleServiceProvider: 'Fornecedor',
    roleHost: 'Anfitrião',
    codeActivated: 'Código ativado',
    codeDeactivated: 'Código desativado',
    codeCreated: 'Código {code} criado',
    createError: 'Erro ao criar o código',
    loadingCodes: 'A carregar códigos...',
    myInviteCodes: 'Os meus códigos de convite',
    newCode: 'Novo código',
    deactivated: 'Desativado',
    exhausted: 'Esgotado',
    uses: 'usos',
    reactivate: 'Reativar',
    deactivate: 'Desativar',
    peopleBrought: 'Pessoas indicadas',
    noPeopleYet: 'Ainda ninguém foi indicado.',
    tableName: 'Nome',
    tableType: 'Tipo',
    tableOrigin: 'Origem',
    tableDate: 'Data',
    manual: 'Manual',
    viaCodeOrigin: 'Código',
    newCodeModalTitle: 'Novo código de convite',
    newCodeModalSubtitle: 'Cria um código para uma campanha específica',
    creating: 'A criar...',
    createCode: 'Criar código',
    label: 'Etiqueta',
    optional: '(opcional)',
    labelPlaceholder: 'Ex.: Campanha Verão 2026',
    labelHint: 'Apenas para a tua organização — não visível publicamente.',
    maxUses: 'Usos máximos',
    maxUsesPlaceholder: 'Ilimitado se vazio',
    maxUsesHint: 'Quantas vezes o código pode ser usado antes de se esgotar.',
    commissionNote: 'A comissão será herdada do teu código principal. Apenas um administrador pode alterar a percentagem.',
  },

  // ============================================
  // PROFILE
  // ============================================
  profile: {
    // Page header
    myProfile: 'O Meu Perfil',
    manageYourAccount: 'Gere os teus dados pessoais, documentos e preferências de pagamento',

    // Sections
    personalData: 'Dados Pessoais',
    address: 'Morada de Residência',
    phoneNumber: 'Número de Telefone',
    documents: 'Documentos de Identidade',
    profilePhoto: 'Foto de Perfil',

    // Personal data fields
    firstName: 'Primeiro Nome',
    firstNamePlaceholder: 'Introduz o teu primeiro nome',
    lastName: 'Apelido',
    lastNamePlaceholder: 'Introduz o teu apelido',
    dateOfBirth: 'Data de Nascimento',
    nationality: 'Nacionalidade',
    nationalityPlaceholder: 'Seleciona a tua nacionalidade',
    fiscalCode: 'Código Fiscal',
    fiscalCodePlaceholder: 'ex.: RSSMRA80A01H501U',
    fiscalCodeHelper: 'Opcional - Apenas para cidadãos italianos',

    // Address fields
    street: 'Rua/Morada',
    streetPlaceholder: 'Rua de Roma, 123',
    city: 'Cidade',
    cityPlaceholder: 'ex.: Olbia',
    postalCode: 'Código Postal',
    postalCodePlaceholder: 'ex.: 07026',
    province: 'Província/Distrito',
    provincePlaceholder: 'ex.: SS',
    country: 'País',
    countryPlaceholder: 'Seleciona o país',

    // Phone fields
    mobilePhone: 'Telemóvel',
    phoneHelper: 'Introduz apenas números, sem espaços ou traços',

    // Document fields
    documentType: 'Tipo de Documento',
    selectDocumentType: 'Seleciona o tipo de documento...',
    identityCard: 'Cartão de Cidadão',
    passport: 'Passaporte',
    drivingLicense: 'Carta de Condução',
    boatLicense: 'Carta Náutica',
    documentNumber: 'Número do Documento',
    documentNumberPlaceholder: 'ex.: AB1234567',
    documentExpiry: 'Data de Validade',
    frontImage: 'Imagem Frontal',
    backImage: 'Imagem Traseira (opcional)',
    clickToUpload: 'Clica para carregar',
    addDocument: 'Adicionar Documento',
    uploadDocument: 'Carregar Documento',
    noDocuments: 'Nenhum documento carregado',
    expiresOn: 'Expira em',
    verified: 'Verificado',
    pending: 'Verificação pendente',
    confirmDeleteDocument: 'Queres eliminar este documento?',
    requiredFields: 'Preenche todos os campos obrigatórios',
    documentTooLarge: 'O ficheiro é demasiado grande. Máximo 10MB.',

    // Avatar
    uploadPhoto: 'Carregar Foto',
    deletePhoto: 'Remover',
    confirmDeleteAvatar: 'Queres remover a foto de perfil?',
    cropImage: 'Recortar Imagem',
    zoom: 'Zoom',
    rotate: 'Rodar',
    invalidImageType: 'Tipo de ficheiro inválido. Usa PNG, JPG ou PDF.',
    imageTooLarge: 'A imagem é demasiado grande. Máximo 5MB.',

    // Email verification
    emailVerification: 'Verificação de Email',
    emailVerified: 'Email Verificado',
    emailNotVerified: 'Email não verificado',
    verify: 'Verificar',
    clickToVerify: 'Clica para verificar',
    resendVerification: 'Reenviar email de verificação',
    emailVerificationDescription: 'Verifica o teu email para desbloquear todas as funcionalidades da tua conta.',
    sendVerificationEmail: 'Enviar Email de Verificação',
    verificationEmailSent: 'Email de verificação enviado! Verifica a tua caixa de entrada.',

    // User profile page
    loginToViewProfile: 'Inicia sessão para ver o teu perfil.',
    myBookings: 'Reservas',
    noBookings: 'Sem reservas',
    unknownBoat: 'Barco desconhecido',
    guest: 'Convidado',
    memberSince: 'Membro desde',
    bookingDetails: 'Detalhes da Reserva',
    embarkationPoint: 'Ponto de Embarque',
    length: 'Comprimento',
    maxCapacity: 'Capacidade Máxima',
    bookingStatus: 'Estado da Reserva',
    totalPaid: 'Total Pago',
    contactSkipper: 'Contactar Skipper',

    downloadReceipt: 'Descarregar Recibo',

    // Success/Error messages
    updateSuccess: 'Perfil atualizado com sucesso!',

    // Profile save (customer form)
    profileUpdated: 'Perfil atualizado',
    saveError: 'Erro ao guardar',
    saving: 'A guardar…',
    saveProfile: 'Guardar perfil',

    // Tab sections
    documentsTitle: 'Documentos',
    documentsSubtitle: 'Carrega a tua identificação e carta náutica',
    paymentMethodsSubtitle: 'Cartões e métodos de pagamento guardados',
    savedBoats: 'Os barcos que guardaste',
    ambassadorTab: 'Embaixador',
    ambassadorProgram: 'Programa de Embaixador',
    ambassadorProgramDesc: 'Convida amigos e ganha comissões sobre os aluguers',

    // Stats hero
    upcoming: 'Próximas',
    total: 'Total',
    nextDeparture: 'Próxima partida',
    today: 'Hoje',
    tomorrow: 'Amanhã',
    inDays: 'Dentro de {n} dias',
    bookingDetailsCta: 'Detalhes da reserva',

    // Bookings list
    bookingSentSuccess: 'Reserva enviada com sucesso',
    bookingSentSuccessDesc: 'Receberás um email de confirmação assim que o proprietário aprovar o pedido.',
    noBookingsYet: 'Ainda sem reservas',
    noBookingsDesc: 'Procura um barco e reserva a tua primeira experiência no mar.',
    searchBoat: 'Procurar um barco',
    boatsSection: 'Barcos',
    experiencesSection: 'Experiências',
    experienceFallback: 'Experiência',
    awaitingOperator: 'A aguardar confirmação do operador',
    reviewed: 'Avaliada',
    leaveReview: 'Deixar uma avaliação',
    reviewSubmittedPending: 'Avaliação submetida, aguarda aprovação.',
    leaveReviewModalTitle: 'Deixar uma avaliação',
    leaveReviewModalSubtitle: 'A tua opinião ajuda outros viajantes',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    bookingCountOne: '{count} reserva',
    bookingCountOther: '{count} reservas',
    notSet: 'Não definido',
    exampleCityPlaceholder: 'Ex.: Olbia',
    exampleVatPlaceholder: 'Ex.: 01692360918',
  },

  // ============================================
  // FAVORITES
  // ============================================
  favorites: {
    title: 'Favoritos',
    empty: 'Nenhum favorito guardado',
    emptyHint: 'Toca no coração dos barcos para os guardares aqui.',
    remove: 'Remover dos favoritos',
    added: 'Adicionado aos favoritos',
    removed: 'Removido dos favoritos',
  },

  // ============================================
  // PAYMENTS
  // ============================================
  payments: {
    paymentMethods: 'Métodos de Pagamento',
    addMethod: 'Adicionar Método',
    noMethods: 'Nenhum método de pagamento guardado',
    addFirstMethod: 'Adiciona o teu primeiro método de pagamento',
    selectType: 'Seleciona o tipo de pagamento',
    creditCard: 'Cartão de Crédito',
    bankTransfer: 'Transferência Bancária',
    cash: 'Dinheiro',
    default: 'Predefinido',
    setAsDefault: 'Definir como predefinido',
    confirmDelete: 'Queres eliminar este método de pagamento?',

    // Credit Card
    cardNumber: 'Número do Cartão',
    cardHolder: 'Titular do Cartão',
    expiryDate: 'Data de Validade',
    expires: 'Expira',
    cardSecurityNote: 'Para a tua segurança, não guardamos o número completo do cartão nem o CVV.',

    // PayPal
    paypalEmail: 'Email do PayPal',

    // IBAN
    accountHolder: 'Titular da Conta',
    bankName: 'Nome do Banco',

    // Common
    label: 'Etiqueta',
    labelPlaceholder: 'ex.: Cartão pessoal, Conta empresarial',
    optional: 'Opcional',
  },

  // ============================================
  // EQUIPMENT (Onboard Equipment)
  // ============================================
  equipment: {
    gps: { label: 'Plotter GPS', description: 'Sistema de navegação GPS com cartografia marítima' },
    vhf: { label: 'Rádio VHF', description: 'Rádio marítimo para comunicações de emergência' },
    anchor: { label: 'Âncora com Corrente', description: 'Âncora completa com corrente e cabo' },
    lifejackets: { label: 'Coletes Salva-vidas', description: 'Coletes salva-vidas para todos os passageiros' },
    bimini: { label: 'Toldo Bimini', description: 'Toldo de sombra para proteção solar' },
    shower: { label: 'Duche de Popa', description: 'Duche de água doce na popa' },
    cooler: { label: 'Frigorífico Portátil', description: 'Frigorífico portátil para bebidas e alimentos' },
    bluetooth: { label: 'Sistema de Som Bluetooth', description: 'Sistema áudio com ligação Bluetooth' },
    ladder: { label: 'Escada de Banho', description: 'Escada retrátil para fácil acesso ao mar' },
    cushions: { label: 'Almofadas de Solário', description: 'Almofadas acolchoadas para relaxar ao sol' },
  },

  // ============================================
  // EXTRAS (Extra Services)
  // ============================================
  extras: {
    skipper: { label: 'Skipper Profissional', description: 'Comandante experiente para a navegação' },
    hostess: { label: 'Hospedeira a Bordo', description: 'Assistência e serviço a bordo' },
    fuel: { label: 'Depósito Cheio', description: 'Depósito cheio incluído no preço' },
    snorkeling: { label: 'Kit de Snorkeling', description: 'Máscara, tubo e barbatanas' },
    sup: { label: 'Stand Up Paddle', description: 'Prancha de SUP com remo' },
    towable: { label: 'Boia Rebocável', description: 'Insuflável rebocável para diversão' },
  },

  // ============================================
  // EXCURSION OPERATOR DASHBOARD
  // ============================================
  excursion: {
    dashboard: 'Painel de Excursões',
    dashboardTitle: 'Painel de Excursões',
    dashboardTitleCompany: 'Painel do Operador',
    dashboardSubtitle: 'Gere o catálogo, horários e reservas',
    menuMain: 'Principal',
    menuFleet: 'Catálogo',
    menuOperations: 'Operações',
    menuFinance: 'Finanças',
    menuSettings: 'Definições',
    fleet: 'Catálogo de excursões',
    calendar: 'Calendário',
    availability: 'Disponibilidade',
    pricing: 'Preços',
    extras: 'Extras',
    bookings: 'Reservas',
    requests: 'Pedidos especiais',
    customRequests: 'Pedidos',
    clients: 'Clientes',
    reviews: 'Avaliações',
    coupons: 'Cupões',
    team: 'Equipa',
    earnings: 'Ganhos',
    earningsByChannel: 'Ganhos por canal',
    reports: 'Relatórios',
    notifications: 'Notificações',
    profile: 'Perfil',
    settings: 'Definições',
    guide: 'Guia do operador',
    roleCompany: 'Empresa',
    roleVendor: 'Operador',
  },
  partner: {
    menuServices: 'Serviços',
    locazione: 'Aluguer',
    escursioni: 'Excursões',
    esperienze: 'Experiências',
    disponibilita: 'Disponibilidade',
    calendarioPartenze: 'Calendário de partidas',
  },

  // ============================================
  // EXCURSION FLOW — public release (modal, magic-link, V2 catalog)
  // ============================================
  customRequests: {
    title: 'Pedidos de orçamento',
    subtitle: 'Pedidos de preço personalizados dos clientes',
    refresh: 'Atualizar',
    filterActionable: 'Por tratar',
    filterAll: 'Todos',
    empty: 'Ainda não há pedidos de orçamento.',
    deletedExcursion: 'Experiência removida',
    status: {
      PENDING: 'Novo',
      VENDOR_PROPOSED: 'Proposta enviada',
      CUSTOMER_COUNTER: 'Contraproposta do cliente',
      ACCEPTED: 'Aceite',
      REJECTED: 'Rejeitado',
      EXPIRED: 'Expirado',
      CONVERTED: 'Reservado',
    },
    drawerTitle: 'Detalhe do pedido',
    noActivity: 'Ainda sem atividade.',
    you: 'Tu',
    customer: 'Cliente',
    validUntil: 'Válido até',
    slotStart: 'Início',
    slotEnd: 'Fim',
    sendProposal: 'Enviar proposta',
    proposalSent: 'Proposta enviada ao cliente.',
    priceInvalid: 'Introduz um preço válido.',
    pricePlaceholder: 'Preço €',
    notesPlaceholder: 'Notas para o cliente (opcional)',
    messagePlaceholder: 'Escreve uma mensagem…',
    reject: 'Rejeitar pedido',
    rejected: 'Pedido rejeitado.',
    rejectReasonPlaceholder: 'Motivo (opcional)',
    confirmReject: 'Confirmar rejeição',
  },
  myRequests: {
    title: 'Os meus pedidos',
    subtitle: 'Orçamentos solicitados e propostas recebidas',
    back: 'Voltar aos pedidos',
    empty: 'Ainda não tens pedidos de orçamento.',
    deletedExcursion: 'Experiência removida',
    status: {
      PENDING: 'A aguardar resposta',
      VENDOR_PROPOSED: 'Proposta recebida',
      CUSTOMER_COUNTER: 'Contraproposta enviada',
      ACCEPTED: 'Aceite',
      REJECTED: 'Rejeitado',
      EXPIRED: 'Expirado',
      CONVERTED: 'Reservado',
    },
  },
  excursionFlow: {
    catalogKicker: 'Sardenha · experiências',
    catalogTitlePart1: 'O que a',
    catalogTitleAccent: 'ilha',
    catalogTitlePart2: 'nunca te conta nos guias turísticos.',
    catalogSubtitle: 'Itinerários guiados e atividades selecionadas por operadores locais — de trekking a passeios de barco, de snorkeling a provas de vinho.',
    catalogCounterLabel: 'Experiências ativas',
    catalogFilterAll: 'Todas',
    catalogEmptyTitle: 'Estamos a preparar as próximas experiências.',
    catalogEmptyBody: 'As excursões da próxima época serão publicadas em breve. Entretanto podes explorar os barcos disponíveis para aluguer.',
    catalogEmptyCta: 'Ver barcos',
    catalogEmptyFilterTitle: 'Nenhuma excursão nesta categoria.',
    catalogEmptyFilterBody: 'Tenta remover o filtro para ver todas as experiências.',
    catalogEmptyFilterCta: 'Ver tudo',

    cardDiscover: 'Descobrir',
    cardFeaturedBadge: 'Destaque',
    cardOnRequest: 'Sob consulta',
    cardFrom: 'Desde',
    cardPerPerson: 'por pessoa',
    cardPerGroup: 'por grupo',
    cardMaxPeople: 'máx.',

    specialRequestCta: 'Fazer um pedido especial',
    modalTitle: 'Pedido especial',
    modalTypeLabel: 'Tipo de pedido',
    typeTimeCustomLabel: 'Horário personalizado',
    typeTimeCustomDesc: 'O mesmo tour, com hora de partida diferente',
    typeGroupCustomLabel: 'Grupo fora do padrão',
    typeGroupCustomDesc: 'Dimensão do grupo fora da capacidade standard',
    typePrivateLabel: 'Tour privado',
    typePrivateDesc: 'Só tu, sem outros participantes',
    typeFullyCustomLabel: 'Experiência totalmente personalizada',
    typeFullyCustomDesc: 'Itinerário / duração / conteúdo diferentes',
    fieldDateStart: 'Data preferida',
    fieldDateEnd: 'Data de fim (se for de vários dias)',
    fieldPeople: 'Pessoas',
    fieldMessage: 'Mensagem para o operador',
    fieldMessagePlaceholder: 'Ex.: Gostaríamos de partir às 16h em vez do horário padrão, somos uma família com 2 crianças de 8 e 10 anos…',
    fieldContactsHeading: 'Os teus dados de contacto',
    fieldName: 'Nome completo',
    fieldEmail: 'Email',
    fieldPhone: 'Telefone (opcional)',
    btnCancel: 'Cancelar',
    btnSendRequest: 'Enviar pedido',
    successTitle: 'Pedido enviado',
    successBody: 'O nosso operador será notificado e responderá por email para {email} com uma proposta personalizada. Verifica também a pasta de spam.',
    successCta: 'Entendido',
    disclaimer: 'Receberás uma resposta por email dentro de algumas horas. O pedido não é vinculativo: podes aceitar ou recusar a proposta final do operador.',

    magicHeroKicker: 'Pedido especial',
    magicHeroGreeting: 'Olá {name}, aqui está a proposta do nosso operador.',
    magicProposalLabel: 'Proposta do vendedor',
    magicProposalTotal: 'total',
    magicProposalWhen: 'Data/hora',
    magicProposalValidUntil: 'Válido até',
    magicProposalNotes: 'Detalhes',
    magicAcceptCta: 'Aceitar e pagar',
    magicRejectCta: 'Recusar',
    magicCounterCta: 'Contraproposta',
    magicCounterTitle: 'Contraproposta',
    magicCounterSubmit: 'Enviar',
    magicAcceptConfirm: 'Confirmas que queres aceitar a proposta? Serás redirecionado para o pagamento.',
    magicRejectPrompt: 'Motivo (opcional, visível ao vendedor):',
    magicRejectConfirm: 'Confirmar recusa?',
    magicLinkExpiredTitle: 'Link inválido',
    magicLinkExpiredBody: 'Pedido não encontrado ou link expirado',
    magicMyRequest: 'O teu pedido',
    magicConversation: 'Conversa',
    magicMsgPlaceholder: 'Escreve ao vendedor…',
    magicValidUntilFooter: 'Link válido até {date}.',
    magicCreateAccount: 'Criar uma conta',
    magicCreateAccountSuffix: 'para geres todos os teus pedidos.',
    magicStatusAccepted: 'Proposta aceite. Prossegue para o pagamento para confirmar.',
    magicStatusConverted: 'Pagamento concluído. A tua excursão está confirmada.',
    magicStatusRejected: 'Proposta recusada.',
    magicStatusExpired: 'Pedido expirado.',
  },

  // ============================================
  // VENDOR DASHBOARD
  // ============================================
  vendor: {
    earningsByChannel: 'Ganhos por canal',
    // Dashboard
    dashboard: 'Painel',
    dashboardTitle: 'Painel do Vendedor',
    dashboardTitleCompany: 'Painel da Empresa',
    dashboardSubtitle: 'Gere os teus barcos e reservas',

    // Sidebar menu groups
    menuMain: 'Principal',
    menuFleet: 'Frota',
    menuOperations: 'Operações',
    menuFinance: 'Finanças',
    menuSettings: 'Definições',
    // Sidebar menu items
    fleet: 'Barcos',
    pricing: 'Preços',
    bulk: 'Operações em massa',
    suspensions: 'Suspensões',
    extras: 'Serviços Extra',
    bookings: 'Reservas',
    customRequests: 'Pedidos',
    clients: 'Clientes',
    reviews: 'Avaliações',
    coupons: 'Cupões',
    team: 'Equipa',
    network: 'Rede e Parceiros',
    earnings: 'Ganhos',
    reports: 'Relatórios',
    analytics: 'Análises',
    notifications: 'Notificações',
    profile: 'Perfil',
    settings: 'Definições',
    guide: 'Guia',
    roleVendor: 'Proprietário de Barco',
    roleCompany: 'Empresa',

    // Navigation (legacy)
    myBoats: 'Os meus barcos',
    myBookings: 'Reservas recebidas',
    myEarnings: 'Ganhos',
    myClients: 'Os meus clientes',
    myExtras: 'Serviços Extra',
    myProfile: 'Perfil de Vendedor',
    calendar: 'Calendário',

    // Tabs
    tabDashboard: 'Painel',
    tabMyBoats: 'Os meus barcos',
    tabCalendar: 'Calendário',
    tabBookings: 'Reservas',
    tabEarnings: 'Ganhos',
    tabClients: 'Clientes',
    tabProfile: 'Perfil',
    tabCompanyProfile: 'Dados da empresa',

    // Stats
    activeBoats: 'Barcos ativos',
    totalBookings: 'Reservas',
    totalRevenue: 'Receita Total',
    totalPayout: 'Pagamento Líquido',
    platformFees: 'Taxas da Plataforma',
    bookingCount: 'Reservas',
    netEarnings: 'Ganhos líquidos',
    pendingPayout: 'Pagamento pendente',
    paidOut: 'Já pago',
    occupancyRate: 'Taxa de Ocupação',
    revenuePerBoat: 'Receita Média/Barco',
    loadingStats: 'A carregar estatísticas...',
    commissionUpdated: 'Comissão atualizada',

    // Boat List
    loadingBoats: 'A carregar barcos...',
    noBoats: 'Nenhum barco',
    noBoatsHint: 'Adiciona o teu primeiro barco a partir do painel de administração',
    boatsCount: 'barcos',
    boatActive: 'Ativo',
    boatInactive: 'Inativo',
    approvalApproved: 'Aprovado',
    approvalPending: 'Em análise',
    approvalRejected: 'Rejeitado',
    approvalNotes: 'Notas:',
    loadBoatsError: 'Erro ao carregar barcos',

    // Calendar
    calendarTitle: 'Calendário de Reservas',
    calendarSubtitle: 'Vê e gere as reservas dos teus barcos',
    loadingCalendar: 'A carregar calendário...',
    noBoatsCalendar: 'Adiciona um barco para ver o calendário',
    allBoats: 'Todos os barcos',
    blockDates: 'Bloquear datas',
    blockDatesTitle: 'Bloquear datas',
    blockingFor: 'A bloquear para',
    startDate: 'Data de início',
    endDate: 'Data de fim',
    blockReason: 'Motivo (opcional)',
    blockReasonPlaceholder: 'Ex.: manutenção, uso pessoal...',
    blockWarning: 'As datas bloqueadas impedirão novas reservas no período selecionado',
    confirmBlock: 'Confirmar bloqueio',
    datesBlocked: 'Datas bloqueadas com sucesso',
    datesUnblocked: 'Datas desbloqueadas',
    blockError: 'Erro ao bloquear datas',
    unblockError: 'Erro ao desbloquear datas',
    selectBoatFirst: 'Seleciona primeiro um barco',
    selectDatesFirst: 'Seleciona as datas a bloquear',
    blockedPeriods: 'Períodos bloqueados',
    unblock: 'Desbloquear',
    fleetOverview: 'Visão geral da frota',
    confirmed: 'confirmadas',
    pendingLabel: 'pendentes',
    blocked: 'bloqueadas',
    noBookingsYet: 'Sem reservas',
    calendarLoadError: 'Erro ao carregar dados do calendário',

    // Bookings
    loadingBookings: 'A carregar reservas...',
    allStatuses: 'Todos os estados',
    pendingBookings: 'Pendentes',
    confirmedRevenue: 'Receita confirmada',
    bookingsTitle: 'Reservas',
    bookingsSubtitle: 'Gerir reservas',
    noBookingsFound: 'Nenhuma reserva encontrada',
    allPaymentStatuses: 'Todos os pagamentos',
    paymentPending: 'Por pagar',
    paymentPaid: 'Pago',
    paymentPartial: 'Parcial',
    paymentRefunded: 'Reembolsado',
    calendarView: 'Calendário',
    listView: 'Lista',
    searchGuest: 'Pesquisar cliente...',
    downloadReceipt: 'Descarregar recibo',
    reversibleBookings: 'Reservas Reversíveis',
    reversibleBookingsSubtitle: 'Podes restaurar o estado anterior',
    boatsOverview: 'Visão Geral dos Barcos',
    cancelWithReason: 'Cancelar com motivo',
    cancelConfirmMessage: 'Tens a certeza de que queres cancelar esta reserva?',
    cancelReasonPlaceholder: 'Motivo do cancelamento (opcional)',
    bookingDetail: 'Detalhe da Reserva',
    guestInfo: 'Informações do Cliente',
    boatInfo: 'Informações do Barco',
    rentalDetails: 'Detalhes do Aluguer',
    experienceDetails: 'Detalhes da experiência',
    priceSummary: 'Resumo do Preço',
    basePrice: 'Preço base',
    insuranceFee: 'Seguro',
    specialRequests: 'Pedidos Especiais',
    cancellationReason: 'Motivo do Cancelamento',
    reverse: 'Restaurar',
    undo: 'Anular',
    statusPending: 'Pendente',
    statusConfirmed: 'Confirmada',
    statusCompleted: 'Concluída',
    statusCancelled: 'Cancelada',
    noBookings: 'Sem reservas',
    boatFallback: 'Barco',
    guestFallback: 'Convidado',
    nights: 'noites',
    guests: 'passageiros',
    netPayout: 'Líquido:',
    loadBookingsError: 'Erro ao carregar reservas',

    // Earnings
    loadingEarnings: 'A carregar ganhos...',
    platformCommission: 'Comissão da plataforma',
    earningsDetail: 'Detalhe dos ganhos',
    headerBoat: 'Barco',
    headerDates: 'Datas',
    headerTotal: 'Total',
    headerCommission: 'Comissão',
    headerNet: 'Líquido',
    headerPayout: 'Pagamento',
    payoutPaid: 'Pago',
    payoutPending: 'Pendente',

    // Client Management
    searchClient: 'Pesquisar cliente...',
    noClients: 'Sem clientes',
    noClientsHint: 'Os clientes aparecerão aqui após a primeira reserva',
    bookingsLabel: 'Reservas',
    spentLabel: 'Gasto',
    loadClientsError: 'Erro ao carregar clientes',

    // Vendor Profile
    profileTitle: 'Perfil de Vendedor',
    profileUpdated: 'Perfil atualizado com sucesso',
    firstName: 'Primeiro Nome',
    firstNamePlaceholder: 'João',
    lastName: 'Apelido',
    lastNamePlaceholder: 'Silva',
    phone: 'Telefone',
    phonePlaceholder: '+351 91 234 5678',
    bio: 'Biografia',
    bioPlaceholder: 'Apresenta-te aos teus clientes...',
    vendorBio: 'Biografia / Descrição',
    vendorPhone: 'Telefone',
    payoutData: 'Dados de Pagamento',
    iban: 'IBAN',
    ibanPlaceholder: 'PT50000201231234567890154',
    payoutIban: 'IBAN para Pagamentos',
    accountHolder: 'Titular da conta',
    accountHolderPlaceholder: 'João Silva',
    payoutHolder: 'Titular da conta',
    saveProfile: 'Guardar perfil',
    loadProfileError: 'Erro ao carregar o perfil',
    saveProfileError: 'Erro ao guardar',

    // Company Profile
    companyData: 'Dados da Empresa',
    companyName: 'Nome da empresa',
    companyNamePlaceholder: 'Sardenha Charter Lda.',
    vatNumber: 'Número de IVA',
    companyVat: 'Número de IVA',
    vatPlaceholder: 'IT12345678901',
    sdiCode: 'Código SDI',
    companySdi: 'Código SDI',
    sdiPlaceholder: 'M5UXCR1',
    pec: 'Correio Eletrónico Certificado (PEC)',
    companyPec: 'Correio Eletrónico Certificado (PEC)',
    pecPlaceholder: 'empresa@pec.it',
    companyPhone: 'Telefone da empresa',
    companyPhonePlaceholder: '+351 21 123 4567',
    officeAddress: 'Morada da sede',
    street: 'Rua',
    streetPlaceholder: 'Rua de Roma 1',
    city: 'Cidade',
    cityPlaceholder: 'Olbia',
    province: 'Província',
    provincePlaceholder: 'SS',
    postalCode: 'Código Postal',
    postalCodePlaceholder: '07026',
    presentation: 'Apresentação',
    companyBioPlaceholder: 'Descreve a tua empresa aos clientes...',
    saveCompanyProfile: 'Guardar perfil da empresa',
    companyProfileUpdated: 'Perfil da empresa atualizado',
    perDay: '/dia',
    saving: 'A guardar...',

    // Booking as guest
    bookingOptions: 'Opções de Reserva',
    canBookAsGuest: 'Também quero reservar barcos',
    canBookAsGuestDesc: 'Ativa esta opção para poderes reservar barcos de outros vendedores como cliente.',
    alsoClient: 'Também cliente',

    // Extras Management
    tabExtras: 'Serviços Extra',
    extrasTitle: 'Os Meus Serviços Extra',
    extrasSubtitle: 'Gere os serviços adicionais dos teus barcos',
    addExtra: 'Novo Extra',
    editExtra: 'Editar Extra',
    noExtras: 'Sem serviços extra',
    noExtrasHint: 'Cria o teu primeiro serviço extra para o oferecer aos clientes',
    extraKey: 'Chave (ID único)',
    extraKeyPlaceholder: 'ex.: skipper_service',
    extraLabel: 'Nome do Serviço',
    extraLabelPlaceholder: 'ex.: Serviço de Skipper',
    extraDescription: 'Descrição',
    extraDescPlaceholder: 'Descreve o serviço extra...',
    extraPrice: 'Preço Predefinido (€)',
    extraPriceType: 'Tipo de Preço',
    pricePerStay: 'Por aluguer',
    pricePerDay: 'Por dia',
    pricePerPerson: 'Por pessoa',
    pricePerPersonDay: 'Por pessoa/dia',
    extraStatusApproved: 'Aprovado',
    extraStatusPending: 'Em análise',
    extraStatusRejected: 'Rejeitado',
    approvalWarning: 'Editar um extra aprovado irá reenviá-lo para aprovação do administrador.',
    editResetsApproval: 'Editar um extra aprovado devolve-o para análise',
    extraCreated: 'Serviço extra criado. A aguardar aprovação.',
    extraUpdated: 'Serviço extra atualizado',
    extraDeleted: 'Serviço extra eliminado',
    extraSaveError: 'Erro ao guardar o serviço extra',
    extraDeleteError: 'Erro ao eliminar o serviço extra',
    rejectionNotes: 'Notas de rejeição',
    loadExtrasError: 'Erro ao carregar os serviços extra',
  },

  // ============================================
  // COMPANY DASHBOARD
  // ============================================
  company: {
    // Menu groups
    menuMain: 'Principal',
    menuFleet: 'Gestão da Frota',
    menuOperations: 'Operações',
    menuFinance: 'Finanças',
    menuSettings: 'Definições',

    // Menu items
    overview: 'Visão Geral',
    fleet: 'Frota',
    calendar: 'Calendário',
    bookings: 'Reservas',
    clients: 'Clientes',
    coupons: 'Cupões',
    team: 'Equipa',
    earnings: 'Ganhos',
    reports: 'Relatórios',
    companyProfile: 'Perfil da Empresa',
    settings: 'Definições',
    companyAccount: 'Conta da Empresa',

    // Overview
    welcomeBack: 'Bem-vindo de volta, {name}',
    overviewSubtitle: 'Visão geral das atividades da tua empresa',
    recentBookings: 'Reservas Recentes',
    viewAll: 'Ver tudo',
    quickActions: 'Ações Rápidas',
    quickFleet: 'Gerir Frota',
    quickFleetDesc: 'Adiciona e gere os teus barcos',
    quickCalendar: 'Calendário',
    quickCalendarDesc: 'Vê disponibilidade e reservas',
    quickReports: 'Relatórios',
    quickReportsDesc: 'Analisa ganhos e gera exportações',

    // Team
    teamSubtitle: 'Gere a tua equipa operacional',
    teamComingSoon: 'Gestão de Equipa brevemente disponível',
    teamComingSoonDesc: 'Em breve poderás adicionar skippers, operadores e gestores à equipa da tua empresa.',
    plannedRoles: 'Funções Planeadas',
    roleSkipper: 'Skipper',
    roleSkipperDesc: 'Comandantes para os teus barcos',
    roleOperator: 'Operador',
    roleOperatorDesc: 'Gestão de reservas e clientes',
    roleManager: 'Gestor',
    roleManagerDesc: 'Supervisão da frota e operações',

    // Reports
    reportsSubtitle: 'Análise detalhada de ganhos',
    dateFrom: 'De',
    dateTo: 'Até',
    clearFilters: 'Repor',
    totalRevenue: 'Receita Total',
    totalCommission: 'Comissões',
    totalNet: 'Líquido',
    noReportData: 'Sem dados para o período selecionado',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    nights: 'Noites',

    // Export
    exportCSV: 'Exportar CSV',
    exportPDF: 'Exportar PDF',
    comingSoon: 'Brevemente disponível',
  },

  // Promo overlay (public)
  promo: {
    close: 'Fechar',
    discover: 'Descobrir',
    bookNow: 'Reservar Agora',
    prev: 'Anterior',
    next: 'Seguinte',
  },

  // Service Provider System
  sp: {
    dashboardTitle: 'Os Meus Serviços',
    dashboardSubtitle: 'Gere os teus pedidos de serviço',
    role: 'Prestador de Serviços',
    tabStats: 'Estatísticas',
    tabRequests: 'Pedidos',
    tabProfile: 'Perfil',
    statsPending: 'Pendentes',
    statsAccepted: 'Aceites',
    statsCompleted: 'Concluídos',
    statsRevenue: 'Receita Mensal',
    statusPENDING: 'Pendente',
    statusBROADCAST: 'Em difusão',
    statusACCEPTED: 'Aceite',
    statusCOMPLETED: 'Concluído',
    statusREJECTED: 'Rejeitado',
    statusCANCELLED: 'Cancelado',
    statusEXPIRED: 'Expirado',
    noRequests: 'Sem pedidos de serviço',
    requestDetail: 'Detalhe do Pedido',
    boat: 'Barco',
    guest: 'Convidado',
    guestPhone: 'Telefone do Convidado',
    passengers: 'Passageiros',
    pickupDate: 'Data de Levantamento',
    returnDate: 'Data de Devolução',
    pickup: 'Local de Levantamento',
    dropoff: 'Destino',
    specialRequests: 'Pedidos Especiais',
    rejectionReason: 'Motivo da Rejeição',
    rejectionReasonPlaceholder: 'Introduz o motivo da rejeição...',
    notes: 'Notas Internas',
    notesPlaceholder: 'Adiciona notas...',
    saveNotes: 'Guardar Notas',
    accept: 'Aceitar',
    reject: 'Rejeitar',
    complete: 'Concluir',
    confirmReject: 'Confirmar Rejeição',
    profileBasic: 'Informações Básicas',
    name: 'Nome',
    phone: 'Telefone',
    license: 'Número de Licença',
    licensePlaceholder: 'Ex. OT/12345',
    bio: 'Descrição',
    fleet: 'Frota de Veículos',
    fleetSize: 'Número de Veículos',
    maxPassengers: 'Máx. Passageiros',
    vehicleTypes: 'Tipos de Veículos',
    vehiclePlaceholder: 'Ex. Sedã, Monovolume de 8 lugares',
    serviceArea: 'Áreas de Serviço',
    serviceAreaPlaceholder: 'Ex. Olbia, Porto Cervo',
    operatingHours: 'Horário de Funcionamento',
    saveProfile: 'Guardar Perfil',
    // Calendar tab
    tabCalendar: 'Calendário',
    calendarTitle: 'Calendário de Compromissos',
    calendarRequests: 'pedidos',
    // Extras tab
    tabExtras: 'Serviços',
    myExtras: 'Os Meus Serviços',
    createExtra: 'Novo Serviço',
    editExtra: 'Editar Serviço',
    extrasEmpty: 'Nenhum serviço criado',
    extraPendingInfo: 'Os novos serviços são enviados para aprovação. Editar um serviço aprovado devolve-o a análise.',
    extraEditWarning: 'Editar um serviço aprovado irá devolvê-lo a "Em análise" para nova aprovação.',
    extraDeleteConfirm: 'Tens a certeza de que queres eliminar',
    extraApproved: 'Aprovado',
    extraPendingReview: 'Em análise',
    extraRejected: 'Rejeitado',
    extraKeyLabel: 'Chave (ID único)',
    extraNameLabel: 'Nome do Serviço',
    extraDescLabel: 'Descrição',
    extraPriceLabel: 'Preço Predefinido (€)',
    extraPriceTypeLabel: 'Tipo de Preço',
    extraSave: 'Guardar Alterações',
    extraCategory: 'Categoria',
    extraCategoryMobility: 'Mobilidade (aluguer e transfers)',
    extraCategoryOther: 'Outro serviço',
    extraPorts: 'Portos de operação *',
    extraPortsHint: 'Seleciona os portos onde ofereces este serviço. Os clientes só verão o serviço para barcos atracados nestes portos.',
    extraPortsEmpty: 'Nenhum porto disponível',
    extraPortsRequired: 'Seleciona pelo menos um porto de operação',
    extraPortsSelectedOne: 'porto selecionado',
    extraPortsSelectedMany: 'portos selecionados',
    extraOperatingAt: 'A operar em',
    pricingMode: 'Modo de preço',
    pricingModeFixed: 'Preço fixo',
    pricingModeQuote: 'Sob consulta (orçamento)',
    pricingModeQuoteHint: 'Os clientes irão pedir um orçamento em vez de verem um preço. Receberás cada pedido no teu painel.',
    priceNotApplicable: 'Não aplicável',
    // Marketplace broadcast (Phase 1)
    broadcastTitle: 'Marketplace ao vivo',
    broadcastHint: 'O primeiro a aceitar fica com o serviço. Sê rápido!',
    claimNow: 'Reclamar agora',
    claimSuccess: 'Pedido aceite!',
    claimLost: 'Já reclamado por outro fornecedor',
    // Empty state — new SP with no linked ServiceProvider profile yet
    noProfileYet: 'Ainda não tens um perfil de fornecedor ativo',
    noProfileHint: 'Aguarda que o administrador te atribua um serviço, ou subscreve um modelo de serviço no separador "As Minhas Ofertas" para começares a receber pedidos do marketplace.',
    pendingApprovalTitle: 'Conta a Aguardar Aprovação',
    pendingApprovalMessage: 'A tua conta está a ser analisada. Serás notificado quando for aprovada.',
    // Generic service keys
    serviceType: 'Tipo de Serviço',
    bikeRental: 'Aluguer de Bicicletas',
    ebikeRental: 'Aluguer de Bicicletas Elétricas',
    scooterRental: 'Aluguer de Scooters',
    monopattinoRental: 'Aluguer de Trotinetes',
    transferPorto: 'Transfer do Porto',
    allServices: 'Todos os Serviços',
    filterByService: 'Filtrar por serviço',
    requestFrom: 'Pedido de',
    quantity: 'Quantidade',
    serviceDate: 'Data do Serviço',
    providerNotes: 'Notas do Fornecedor',
    // Error / toast messages
    errLoadRequests: 'Não foi possível carregar os pedidos de serviço',
    errLoadStats: 'Não foi possível carregar as estatísticas',
    errLoadCalendar: 'Não foi possível carregar o calendário',
    errLoadProfile: 'Não foi possível carregar o perfil',
    errSaveProfile: 'Não foi possível guardar o perfil',
    errAcceptRequest: 'Não foi possível aceitar o pedido',
    errRejectRequest: 'Não foi possível rejeitar o pedido',
    errCompleteRequest: 'Não foi possível concluir o pedido',
    errSaveNotes: 'Não foi possível guardar as notas',
    profileSaved: 'Perfil guardado com sucesso',
    notesSaved: 'Notas guardadas',
    capacityCheck: 'Verificação automática de capacidade',
    capacityCheckEnabled: 'Bloqueio automático ativado',
    capacityCheckDisabled: 'Bloqueio automático desativado',
    capacityCheckHintEnabled: 'Quando ativado, o sistema rejeita automaticamente novos pedidos se já tiveres atingido a capacidade máxima configurada para essa data.',
    capacityCheckHintDisabled: 'Receberás todos os pedidos mesmo além da capacidade configurada e terás de resolver manualmente quaisquer conflitos.',
    capacityCheckSaved: 'Definição de capacidade atualizada',
    capacityExhausted: 'O fornecedor não tem disponibilidade para a data solicitada',
    // Payment collection mode
    paymentMode: 'Modo de cobrança do pagamento',
    paymentModeFull: 'A plataforma cobra tudo',
    paymentModeFullDesc: 'A plataforma cobra o valor total da reserva e paga-te o líquido por transferência bancária.',
    paymentModeCommissionOnly: 'A plataforma cobra apenas a comissão',
    paymentModeCommissionDesc: 'A plataforma cobra apenas a sua comissão. O restante é pago diretamente a ti pelo cliente no check-in (dinheiro ou cartão).',
    paymentModeFullHint: 'Modo padrão: tudo passa pela plataforma e recebes o líquido por transferência bancária.',
    paymentModeCommissionHint: 'Neste modo os clientes pagam-te o restante diretamente no porto. A plataforma retém apenas a sua percentagem.',
    spIban: 'IBAN para Pagamentos',
    spIbanHolder: 'Titular da conta',
    paymentModeSaved: 'Modo de cobrança do pagamento guardado',
    // SP catalog (offers tab)
    tabOffers: 'As minhas ofertas',
    offersTitle: 'Catálogo de ofertas',
    offersDesc: 'Subscreve modelos de serviço criados pelo administrador com o teu próprio preço',
    offersAdd: 'Adicionar oferta',
    offersEdit: 'Editar oferta',
    offersDelete: 'Eliminar oferta',
    offersSelectTemplate: 'Selecionar modelo',
    offersCustomPrice: 'Preço personalizado',
    offersCapacity: 'Capacidade',
    offersNotes: 'Notas',
    offersPorts: 'Portos de operação',
    offersEmpty: 'Sem ofertas ativas. Adiciona uma para começar.',
    offersNoTemplates: 'Nenhum modelo disponível. O administrador tem de criar pelo menos um.',
    offersCreated: 'Oferta criada',
    offersUpdated: 'Oferta atualizada',
    offersDeleted: 'Oferta eliminada',
  },

  // ============================================
  // SERVICES SUBDOMAIN
  // ============================================
  servicesLogin: {
    title: 'Insula Services',
    subtitle: 'Área do Prestador de Serviços',
    sectionLabel: 'Acesso do Fornecedor',
    submit: 'Entrar',
    submitting: 'A entrar...',
    accessDenied: 'Esta área é reservada a prestadores de serviços.',
    copyright: 'Todos os direitos reservados.',
  },
  servicesCatalog: {
    title: 'Serviços Disponíveis',
    subtitle: 'Os nossos parceiros de serviços locais',
    noProviders: 'Nenhum fornecedor disponível neste momento',
    becomeProvider: 'Tornar-me Fornecedor',
    requestService: 'Pedir um Serviço',
    serviceArea: 'Áreas de Serviço',
    vehicleTypes: 'Veículos',
    maxPassengers: 'Máx. Passageiros',
    howItWorks: 'Como Funciona',
    howItWorksDesc: 'Reserva uma viagem de barco e adiciona o serviço de transfer. Um fornecedor local trata do teu transporte.',
  },
  servicesNavbar: {
    dashboard: 'Painel',
    catalog: 'Catálogo de Serviços',
    login: 'Entrar',
    logout: 'Sair',
  },

  // ============================================
  // SP SELF-REGISTRATION WIZARD
  // ============================================
  spReg: {
    title: 'Torna-te Prestador de Serviços',
    subtitle: 'Junta-te à plataforma Insula Services em poucos passos.',
    becomeProvider: 'Tornar-me Fornecedor',
    step1Title: 'Conta',
    step2Title: 'Dados do negócio',
    step3Title: 'Categorias e portos',
    step4Title: 'Revisão',
    next: 'Seguinte',
    previous: 'Voltar',
    submit: 'Submeter pedido',
    fieldName: 'Nome completo',
    fieldEmail: 'Email',
    fieldPassword: 'Palavra-passe',
    fieldPasswordConfirm: 'Confirmar palavra-passe',
    fieldPhonePrefix: 'Prefixo',
    fieldPhoneNumber: 'Telefone',
    fieldCompanyName: 'Nome da empresa',
    fieldVAT: 'Número de IVA',
    fieldTaxCode: 'Código fiscal',
    fieldAddress: 'Morada',
    fieldCity: 'Cidade',
    fieldProvince: 'Província',
    fieldPostalCode: 'Código postal',
    selectCategories: 'Categorias de serviço oferecidas',
    selectPorts: 'Portos de operação',
    summaryTitle: 'Revê os teus dados',
    summaryHint: 'Confirma que tudo está correto antes de submeteres o teu pedido de registo.',
    successTitle: 'Pedido submetido',
    successMessage: 'O teu registo foi recebido. Um administrador irá analisá-lo em breve e serás notificado por email.',
    errors: {
      required: 'Este campo é obrigatório',
      emailInvalid: 'Email inválido',
      passwordWeak: 'A palavra-passe deve ter pelo menos 8 caracteres',
      passwordMismatch: 'As palavras-passe não coincidem',
      selectCategory: 'Seleciona pelo menos uma categoria',
      selectPort: 'Seleciona pelo menos um porto',
      emailExists: 'Este email já está registado',
      generic: 'Algo correu mal. Tenta novamente.',
    },
  },

  boatWizard: {
    useType: {
      label: 'Uso previsto',
      locazione: { label: 'Aluguer bareboat', desc: 'Aluguer sem skipper (bareboat): aparece no catálogo de aluguer' },
      excursionOnly: { label: 'Apenas excursões', desc: 'Usado apenas para excursões/experiências, excluído do catálogo de aluguer' },
    },
    pricingMode: {
      label: 'Modo de preço',
      fixed: { label: 'Preço fixo', desc: 'Preços visíveis: os clientes veem os preços e podem reservar diretamente' },
      quoteOnRequest: { label: 'Orçamento sob consulta', desc: 'Os clientes enviam um pedido de orçamento; tu respondes com um preço personalizado' },
      priceFieldsHidden: 'Os campos de preço estão ocultos porque o barco está definido como "Orçamento sob consulta".',
    },
  },

};

export default pt;
